/*
  assets/gtender-public-entry.js — GTENDER-PUBLIC-FREE-RUNTIME-19
  Owner: /pages/gtender anonymous public tender feed + Authenticated account state awareness.
  Boundary: Anonymous read-only public opportunities through the canonical GCity public API.
*/
(function () {
  'use strict';

  var VERSION = 'gtender-public-free-runtime-19-opportunity-map';
  var ROOT_SELECTOR = '[data-gtender-public-entry]';
  var PUBLIC_API_ORIGIN = 'https://api.glhksolution.com';
  var SEARCH_FALLBACK = PUBLIC_API_ORIGIN + '/api/tender/search';
  var DETAIL_FALLBACK = PUBLIC_API_ORIGIN + '/api/tender/detail';
  var SOURCE_STATUS_FALLBACK = PUBLIC_API_ORIGIN + '/api/tender/source/status';
  var SOURCE_CLIENT_STORAGE_KEY = 'littleg:public-source-client:v1';
  var SOURCE_CLIENT_PATTERN = /^[A-Za-z0-9_-]{12,80}$/;
  var SEARCH_PAGE_SIZE = 20;
  var DETAIL_REQUEST_TIMEOUT_MS = 10000;
  var SHARED_TENDER_ID_RE = /^[A-Za-z0-9._:-]{3,240}$/;
  var stateByRoot = new WeakMap();

  var COPY = {
    en: {
      officialSource: 'Official source', sourcePrefix: 'Source', verifiedAsOf: 'Verified as of', updated: 'Updated',
      healthCurrent: 'Tender data is up to date', healthStale: 'Official tender data may be delayed',
      healthStaleTail: 'Existing records remain available for reference.',
      healthError: 'Official source update is temporarily unavailable. Existing tender records may be older than usual.',
      healthChecking: 'Checking official data freshness…', source: 'Source', category: 'Category', tenderDetail: 'Tender detail',
      notProvided: 'Not provided', notClassified: 'Not classified', loadingDetail: 'Loading full tender detail…',
      detailUnavailable: 'Tender details could not be loaded. Please try again later.',
      publicTender: 'Public tender', closing: 'Closing', viewDetails: 'View details', viewOfficial: 'View Requirements',
      allCategories: 'All', allDepartments: 'All organisations',
      noVerified: 'No public tender records are available from the current feed.',
      noMatch: 'No tenders match the current search and filters.',
      clearFilters: 'Clear filters', previous: 'Previous', next: 'Next', share: 'Share', copied: 'Link copied', copyLink: 'Copy this link',
      shareLead: 'I found this tender on GTender and thought it might be useful:',
      cardClosing: 'Closing: ', budgetPrefix: 'Budget: ', budgetMissing: 'Budget not disclosed', recentSearches: 'Recent searches · This device only', deleteSearch: 'Delete search: ', clearSearchHistory: 'Clear search history',
      mapLoading: 'Loading verified Place relationships…', loadFailed: 'Could not load tenders', retryHint: 'Please try again.', retryAction: 'Try Again', sourceStatusUnavailable: 'Source status is unavailable.',
      todayPrefix: 'today ', latestSuccess: 'Latest success (source times vary): ', hkTimeSuffix: ' HK',
      refreshSuccess: 'Refresh succeeded', refreshFailure: 'Refresh failed', lastSuccess: 'Last successful sync: ', timeMissing: 'time unavailable', postedDate: 'Posted date',
    searching: 'Searching verified public tenders…',
      matchLabel: 'Match', officialRequirements: 'Official requirements', requirementsMissing: 'Not provided in official data',
      locationLabel: 'Location', locationPending: 'Location pending verification', nextStepLabel: 'Next step', regionHongKong: 'Hong Kong',
      sourceUnavailable: 'Could not load tenders. Your search and filters are unchanged. Select Search to retry.'
    },
    zh: {
      officialSource: '官方來源', sourcePrefix: '來源', verifiedAsOf: '核實至', updated: '更新於',
      healthCurrent: '資料更新正常', healthStale: '官方招標資料可能延遲', healthStaleTail: '現有記錄仍保留供參考。',
      healthError: '官方來源暫時無法更新，現有招標記錄可能較平常舊。', healthChecking: '正在檢查官方資料更新狀態…',
      source: '來源', category: '分類', tenderDetail: '招標詳情', notProvided: '未提供', notClassified: '未分類',
      loadingDetail: '正在載入完整招標詳情…',
      detailUnavailable: '暫時無法載入招標詳情，請稍後再試。',
      publicTender: '公開招標', closing: '截止', viewDetails: '查看詳情', viewOfficial: '查看投標要求',
      allCategories: '全部分類', allDepartments: '全部機構',
      noVerified: '目前資料來源沒有可顯示的公開招標記錄。', noMatch: '沒有招標符合目前的搜尋及篩選條件。',
      clearFilters: '清除篩選', previous: '上一頁', next: '下一頁', share: '分享', copied: '已複製連結', copyLink: '請複製此連結',
      shareLead: '我在 GTender 找到這個招標，推薦你看看：',
      cardClosing: '截標：', budgetPrefix: '預算：', budgetMissing: '預算未披露', recentSearches: '近期搜尋（僅儲存在此裝置）', deleteSearch: '刪除搜尋：', clearSearchHistory: '清空搜尋紀錄',
      mapLoading: '正在讀取已核實的位置關聯…', loadFailed: '暫時未能載入', retryHint: '請稍後再試。', retryAction: '重試', sourceStatusUnavailable: '暫時無法確認來源更新。',
      todayPrefix: '今日 ', latestSuccess: '最近成功（各來源時間不同）：', hkTimeSuffix: '（香港時間）',
      cardClosing: '截标：', budgetPrefix: '预算：', budgetMissing: '预算未披露', recentSearches: '近期搜索（仅保存在此设备）', deleteSearch: '删除搜索：', clearSearchHistory: '清空搜索记录',
    mapLoading: '正在读取已核实的位置关联…', loadFailed: '暂时无法加载', retryHint: '请稍后重试。', retryAction: '重试', sourceStatusUnavailable: '暂时无法确认来源更新。',
    todayPrefix: '今天 ', latestSuccess: '最近成功（各来源时间不同）：', hkTimeSuffix: '（香港时间）',
    refreshSuccess: '更新成功', refreshFailure: '更新失敗', lastSuccess: '最後成功同步：', timeMissing: '時間未提供', postedDate: '發布日期',
  searching: '正在搜尋已核實的公開招標…',
      matchLabel: '匹配', officialRequirements: '官方資格要求', requirementsMissing: '官方資料未提供',
      locationLabel: '位置', locationPending: '位置待核實', nextStepLabel: '下一步', regionHongKong: '香港',
      sourceUnavailable: '暫時無法載入'
    }
  };

  // Simplified Chinese is a copy-only variant. Keep localeFamily()'s existing
  // zh/en control-flow contract so query/state/view selectors do not change.
  COPY['zh-CN'] = Object.assign({}, COPY.zh, {
    officialSource: '官方来源', sourcePrefix: '来源', verifiedAsOf: '核实截至', updated: '更新于',
    healthCurrent: '数据更新正常', healthStale: '官方招标数据可能延迟',
    healthStaleTail: '现有记录仍保留供参考。',
    healthError: '官方来源暂时无法更新，现有招标记录可能较平常旧。',
    healthChecking: '正在检查官方数据更新状态…',
    source: '来源', category: '分类', tenderDetail: '招标详情',
    notProvided: '未提供', notClassified: '未分类',
    loadingDetail: '正在加载完整招标详情…',
    detailUnavailable: '暂时无法加载招标详情，请稍后再试。',
    publicTender: '公开招标', closing: '截止', viewDetails: '查看详情',
    viewOfficial: '查看官方公告', allCategories: '全部分类',
    allDepartments: '全部机构', noVerified: '目前数据来源没有可显示的公开招标记录。',
    noMatch: '没有招标符合当前的搜索及筛选条件。',
    clearFilters: '清除筛选', previous: '上一页', next: '下一页',
    share: '分享', copied: '已复制链接', copyLink: '请复制此链接',
    shareLead: '我在 GTender 找到这个招标，推荐你看看：',
    refreshSuccess: '更新成功', refreshFailure: '更新失败', lastSuccess: '最后成功同步：', timeMissing: '时间未提供', postedDate: '发布日期',
    searching: '正在搜索已核实的公开招标…',
    matchLabel: '匹配', officialRequirements: '官方资格要求', requirementsMissing: '官方资料未提供',
    locationLabel: '位置', locationPending: '位置待核实', nextStepLabel: '下一步', regionHongKong: '香港',
    sourceUnavailable: '暂时无法加载'
  });

  var CATEGORY_ZH = {
    'supply-stores': '物資及設備',
    'public-works': '公共工程',
    'property-land': '土地及物業',
    'transport-mobility': '交通及流動',
    'digital-it': '數碼及資訊科技',
    'community-survey-education': '社區、調查及教育',
    'other-government-services': '其他政府服務'
  };

  var SOURCE_NAMES = {
    'edb': { zh: '教育局', en: 'Education Bureau' },
    'hkust': { zh: '香港科技大學', en: 'Hong Kong University of Science and Technology' },
    'hkmu': { zh: '香港都會大學', en: 'Hong Kong Metropolitan University' },
    'gld-etb': { zh: '香港特別行政區政府物流服務署', en: 'HKSAR Government Logistics Department' },
    'archsd': { zh: '香港特別行政區建築署', en: 'HKSAR Architectural Services Department' },
    'gpa': { zh: '政府產業署', en: 'Government Property Agency' },
    'hkma': { zh: '香港金融管理局', en: 'Hong Kong Monetary Authority' },
    'ha': { zh: '醫院管理局', en: 'Hospital Authority' },
    'cedd': { zh: '土木工程拓展署', en: 'Civil Engineering and Development Department' },
    'emsd': { zh: '機電工程署', en: 'Electrical and Mechanical Services Department' },
    'wsd': { zh: '水務署', en: 'Water Supplies Department' },
    'epd': { zh: '環境保護署', en: 'Environmental Protection Department' },
    'hyd': { zh: '路政署', en: 'Highways Department' }
  };

  var SOURCE_SHORT_NAMES = {
    'gld-etb': 'HKSAR GLD',
    'archsd': 'ArchSD',
    'gpa': 'GPA',
    'hkma': 'HKMA',
    'ha': 'HA',
    'cedd': 'CEDD',
    'emsd': 'EMSD',
    'wsd': 'WSD',
    'epd': 'EPD',
    'hyd': 'HyD'
  };

  var TRUSTED_DOMAINS = [
    'gov.hk', 'ha.org.hk', 'hkairport.com', 'mtr.com.hk', 'westkowloon.hk', 'hksp.org', 'cyberport.hk', 'hkp.com.hk', 'w5.ab.ust.hk', 'etender.hkmu.edu.hk'
  ];

  function clean(value) { return String(value == null ? '' : value).trim(); }
  function normalized(value) { return clean(value).toLowerCase().replace(/\s+/g, ' '); }

  function localeFamily() {
    var root = document.querySelector(ROOT_SELECTOR);
    var raw = clean(root && root.getAttribute('data-locale')) || clean(document.documentElement && document.documentElement.lang) || clean(window.Shopify && window.Shopify.locale) || 'en';
    return raw.toLowerCase().indexOf('zh') === 0 ? 'zh' : 'en';
  }

  function copy(key) {
    var root = document.querySelector(ROOT_SELECTOR);
    var raw = clean(root && root.getAttribute('data-locale')) ||
      clean(document.documentElement && document.documentElement.lang) ||
      clean(window.Shopify && window.Shopify.locale);
    var family = /^zh-(?:cn|hans|sg)(?:$|-)/i.test(raw) ? 'zh-CN' : localeFamily();
    return COPY[family][key] || COPY.en[key] || key;
  }

  function gtenderTenderUrl(id) {
    var key = clean(id);
    if (!SHARED_TENDER_ID_RE.test(key)) return '';
    try {
      var url = new URL(window.location.href);
      url.search = '';
      url.hash = '';
      url.searchParams.set('tender', key);
      return url.toString();
    } catch (_error) { return ''; }
  }

  function shareMessage(title) {
    return copy('shareLead') + '\n' + clean(title);
  }

  function shareClipboardText(title, url) {
    return shareMessage(title) + '\n' + url;
  }

  function sourceClientUid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return 'src_' + window.crypto.randomUUID().replace(/-/g, '');
    } catch (_error) {}
    try {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return 'src_' + Array.prototype.map.call(bytes, function (value) { return value.toString(16).padStart(2, '0'); }).join('');
    } catch (_error) { return 'src_session_' + Date.now().toString(36); }
  }

  function publicSourceClientId() {
    try {
      var existing = clean(window.localStorage.getItem(SOURCE_CLIENT_STORAGE_KEY));
      if (SOURCE_CLIENT_PATTERN.test(existing)) return existing;
      var created = sourceClientUid();
      window.localStorage.setItem(SOURCE_CLIENT_STORAGE_KEY, created);
      return created;
    } catch (_error) {
      if (!window.__gtenderPublicSourceSessionId) window.__gtenderPublicSourceSessionId = sourceClientUid();
      return window.__gtenderPublicSourceSessionId;
    }
  }

  function attachSourceClient(url) {
    var id = publicSourceClientId();
    if (id && !url.searchParams.has('source_client')) url.searchParams.set('source_client', id);
    return url;
  }

  function canonicalPublicEndpoint(value, fallbackUrl) {
    var fallback = new URL(fallbackUrl);
    var raw = clean(value) || fallbackUrl;
    try {
      var url = new URL(raw, window.location.origin);
      if (url.protocol !== 'https:' || url.origin !== PUBLIC_API_ORIGIN) return fallback;
      return url;
    } catch (_error) { return fallback; }
  }

  function responseData(payload) {
    if (!payload || typeof payload !== 'object') return {};
    return payload.data && typeof payload.data === 'object' ? payload.data : payload;
  }

  function firstArray(payload) {
    var nested = responseData(payload);
    var candidates = [payload && payload.items, payload && payload.results, nested.items, nested.results];
    for (var i = 0; i < candidates.length; i += 1) {
      if (!Array.isArray(candidates[i])) continue;
      if (!candidates[i].every(function (item) {
        return item && typeof item === 'object' && !Array.isArray(item);
      })) throw new Error('public_search_payload_unavailable');
      return candidates[i];
    }
    throw new Error('public_search_payload_unavailable');
  }

  function detailItem(payload) {
    if (!payload || typeof payload !== 'object') return null;
    if (payload.item && typeof payload.item === 'object') return payload.item;
    if (payload.data && payload.data.item && typeof payload.data.item === 'object') return payload.data.item;
    return null;
  }

  function safeOfficialUrl(value) {
    var raw = clean(value);
    if (!raw) return '';
    try {
      var url = new URL(raw);
      if (url.protocol !== 'https:') return '';
      var host = url.hostname.toLowerCase();
      var isTrusted = TRUSTED_DOMAINS.some(function (domain) { return host === domain || host.endsWith('.' + domain); });
      return isTrusted ? url.toString() : '';
    } catch (_error) { return ''; }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }

  function sourceKey(item) {
    var provenance = item && item.provenance && typeof item.provenance === 'object' ? item.provenance : {};
    return normalized(clean(item && item.source) || clean(provenance.source));
  }

  function sourceIdentity(item) {
    var rawKey = sourceKey(item);
    var isZh = localeFamily() === 'zh';
    if (SOURCE_NAMES[rawKey]) return isZh ? SOURCE_NAMES[rawKey].zh : SOURCE_NAMES[rawKey].en;
    var provenance = item && item.provenance && typeof item.provenance === 'object' ? item.provenance : {};
    var raw = clean(item && item.source) || clean(provenance.source);
    var generic = !rawKey || /^(?:source|official source|official-source|external|unknown|n\/?a|na)$/.test(rawKey);
    if (!generic && raw) return raw;
    return detailDepartment(item) || copy('officialSource');
  }

  function sourceShortIdentity(item) {
    return SOURCE_SHORT_NAMES[sourceKey(item)] || sourceIdentity(item);
  }

  function recordVerifiedAt(item, fallback) {
    var provenance = item && item.provenance && typeof item.provenance === 'object' ? item.provenance : {};
    return clean(item && item.last_verified_at) || clean(item && item.last_seen_at) || clean(item && item.source_fetched_at) || clean(provenance.last_seen_at) || clean(provenance.source_fetched_at) || clean(fallback);
  }

  function formatAsOf(value) {
    var raw = clean(value);
    if (!raw) return '';
    var parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) return raw;
    try {
      return new Intl.DateTimeFormat(localeFamily() === 'zh' ? 'zh-TW' : 'en', {
        year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Hong_Kong'
      }).format(parsed) + ' HKT';
    } catch (_error) { return parsed.toISOString(); }
  }

  function compactUpdatedAt(value) {
    var raw = clean(value);
    if (!raw) return '';
    var parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) return '';
    try {
      var locale = localeFamily() === 'zh' ? 'zh-TW' : 'en';
      var dayFormat = new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Asia/Hong_Kong' });
      var time = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Hong_Kong' }).format(parsed);
      if (dayFormat.format(parsed) === dayFormat.format(new Date())) return copy('todayPrefix') + time;
      return new Intl.DateTimeFormat(locale, { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Hong_Kong' }).format(parsed);
    } catch (_error) { return ''; }
  }

  function provenanceText(item) {
    return copy('sourcePrefix') + ': ' + sourceShortIdentity(item);
  }

  function renderSourceSummary(root, state) {
    var banner = root.querySelector('[data-gtender-source-health]');
    var text = root.querySelector('[data-gtender-source-health-text]');
    if (banner) {
      const hasSourceData = Object.keys(state.sources || {}).length > 0;

      banner.hidden =
        state.healthDismissed ||
        state.sourceHealth === 'checking' ||
        hasSourceData;
      banner.setAttribute('data-source-state', root.getAttribute('data-source-freshness'));
    }
    if (text) text.textContent = sourceHealthText(state.sourceHealth, '');
    var sources = state.sources || {};
    var keys = Object.keys(sources).sort();
    var successful = keys.filter(function (key) { return sources[key] && sources[key].ok === true; }).length;
    var summary = root.querySelector('[data-gtender-source-summary]');
    var label = root.querySelector('[data-gtender-source-summary-label]');
    var list = root.querySelector('[data-gtender-source-list]');
    if (summary) {
      const hasDetails = keys.length > 0;
      const toggle = summary.querySelector('summary');

      if (!hasDetails) summary.open = false;

      if (toggle) {
        toggle.style.pointerEvents = hasDetails ? '' : 'none';
        toggle.style.listStyle = hasDetails ? '' : 'none';
        toggle.style.cursor = hasDetails ? '' : 'default';
        toggle.setAttribute('tabindex', hasDetails ? '0' : '-1');
      }
    }
    if (label) {
      var count = successful + '/' + keys.length;
      const sourceLabels = localeFamily() === 'zh'
        ? {
            current: '來源狀態',
            stale: '來源更新可能延遲',
            error: '暫時未能確認更新狀態，請核對官方公告。',
            checking: '正在確認來源狀態'
          }
        : {
            current: 'Source status',
            stale: 'Source updates may be delayed',
            error: 'Update status could not be checked. Please verify the official notice.',
            checking: 'Checking source status'
          };

      label.textContent =
        sourceLabels[state.sourceHealth] || sourceLabels.error;
      var sourceCount = root.querySelector('[data-gtender-source-count]');
      if (sourceCount) {
        sourceCount.hidden = keys.length === 0;
        sourceCount.textContent = keys.length
          ? (localeFamily() === 'zh'
              ? '最近更新：' + count + ' 個來源成功'
              : 'Latest refresh: ' + count + ' sources succeeded')
          : '';
      }
    }
    if (list) {
      list.textContent = '';
      keys.forEach(function (key) {
        var source = sources[key] || {};
        var ok = source.ok === true;
        var time = compactUpdatedAt(ok ? source.fetched_at : source.last_success_at);
        var status = copy(ok ? 'refreshSuccess' : 'refreshFailure');
        var last = copy('lastSuccess');
        var unavailable = copy('timeMissing');
        list.appendChild(element('li', '', sourceIdentity({ source: key }) + ' — ' + status + ' · ' + last + (time || unavailable)));
      });
    }
    var timestamp = root.querySelector('[data-gtender-sync-time]');
    var formatted = compactUpdatedAt(state.syncAt);
    if (timestamp) {
      timestamp.hidden = !formatted;
      timestamp.textContent = formatted ? copy('latestSuccess') + formatted + copy('hkTimeSuffix') : '';
    }
  }

  function updateSyncTime(root, state, values) {
    values.forEach(function (value) {
      if (Number.isFinite(Date.parse(value)) && (!state.syncAt || Date.parse(value) > Date.parse(state.syncAt))) state.syncAt = value;
    });
    renderSourceSummary(root, state);
  }

  function officialDateText(value) {
    var raw = clean(value);
    if (!raw) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return Number.isFinite(Date.parse(raw)) ? raw : '';
    if (/^\d{4}-\d{2}-\d{2}T.*(?:Z|[+-]\d{2}:?\d{2})$/.test(raw)) {
      var parsed = new Date(raw);
      if (!Number.isFinite(parsed.getTime())) return '';
      return new Intl.DateTimeFormat(localeFamily() === 'zh' ? 'zh-TW' : 'en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Hong_Kong' }).format(parsed) + (localeFamily() === 'zh' ? '（香港時間）' : ' (Hong Kong time)');
    }
    return raw;
  }

  function getDeadlineBadgeInfo(deadlineStr) {
    const raw = clean(deadlineStr);
    if (!raw) return null;

    const zh = localeFamily() === 'zh';

    // A date without a time is not an exact deadline instant.
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null;

    const instant = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(?::\d{2})?$/.test(raw)
      ? raw.replace(' ', 'T') + '+08:00'
      : raw;

    // Do not interpret timezone-less values in the visitor's local timezone.
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})$/i.test(instant)) {
      return null;
    }

    const deadline = Date.parse(instant);
    if (!Number.isFinite(deadline)) return null;

    const remaining = deadline - Date.now();

    if (remaining <= 0) {
      return {
        text: zh ? '截標時間已過' : 'Expired',
        state: 'expired'
      };
    }

    const totalHours = Math.floor(remaining / 3600000);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;

    const text = totalHours < 1
      ? zh ? '不足 1 小時截標' : 'Closes in under 1 hour'
      : days > 0
        ? zh
          ? '倒數 ' + days + ' 天 ' + hours + ' 小時'
          : days + 'd ' + hours + 'h remaining'
        : zh
          ? '倒數 ' + hours + ' 小時'
          : hours + 'h remaining';

    return {
      text: text,
      state: remaining < 72 * 3600000
        ? 'urgent'
        : remaining <= 7 * 86400000
          ? 'warning'
          : 'normal'
    };
  }

  /*
    P870-C16 frontend projection only.
    Canonical lifecycle remains backend-owned.
    Deadline presentation never creates terminal truth.
  */
  function lifecycleInfo(item) {
    var raw = normalized(
      item &&
      (item.status || item.source_status)
    );
    var zh = localeFamily() === 'zh';

    // A past, explicitly dated deadline is not a verified terminal status.
    // Prevent stale source statuses from being presented as open/closing.
    // Keep cancelled/suspended/closed authority with the backend.
    if (/^(open|issued|active|closing)$/.test(raw)) {
      var deadlineInfo = getDeadlineBadgeInfo(item && (item.closing_datetime_raw || item.deadline));
      if (deadlineInfo && deadlineInfo.state === 'expired') {
        return {
          key: 'deadline-passed',
          label: zh ? '截標時間已過，請核實公告' : 'Deadline passed · verify notice',
          tone: 'unavailable'
        };
      }
    }

    if (/^(open|issued|active)$/.test(raw)) {
      return {
        key: 'open',
        label: zh ? '開放中' : 'Open',
        tone: 'open'
      };
    }

    if (raw === 'closing') {
      return {
        key: 'closing',
        label: zh ? '即將截止' : 'Closing soon',
        tone: 'closing'
      };
    }

    if (raw === 'closed') {
      return {
        key: 'closed',
        label: zh ? '已截止' : 'Closed',
        tone: 'terminal'
      };
    }

    if (
      raw === 'cancelled' ||
      raw === 'canceled'
    ) {
      return {
        key: 'cancelled',
        label: zh ? '已取消' : 'Cancelled',
        tone: 'terminal'
      };
    }

    if (raw === 'suspended') {
      return {
        key: 'suspended',
        label: zh ? '已暫停' : 'Suspended',
        tone: 'terminal'
      };
    }

    if (raw === 'unavailable') {
      return {
        key: 'unavailable',
        label: zh
          ? '暫時無法確認'
          : 'Temporarily unavailable',
        tone: 'unavailable'
      };
    }

    return raw
      ? {
          key: 'unknown',
          label: clean(
            item &&
            (item.status || item.source_status)
          ),
          tone: 'neutral'
        }
      : {
          key: '',
          label: '',
          tone: 'neutral'
        };
  }

  function categoryLabel(value) {
    var raw = clean(value);
    if (!raw) return '';
    var key = normalized(raw);
    if (localeFamily() === 'zh' && CATEGORY_ZH[key]) return CATEGORY_ZH[key];
    if (key === 'digital-it') return 'Digital IT';
    if (key === 'community-survey-education') return 'Community, Surveys & Education';
    return raw.replace(/[_-]+/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function setStatus(root, text) {
    var node = root.querySelector('[data-gtender-public-status]');
    if (node) node.textContent = text;
  }

  function sourceHealthText(state, updatedAt) {
    var asOf = compactUpdatedAt(updatedAt);
    if (state === 'current') return copy('healthCurrent') + (asOf ? ' · ' + copy('updated') + ' ' + asOf : '');
    if (state === 'stale') return copy('healthStale') + (asOf ? ' · ' + copy('updated') + ' ' + asOf : '') + '. ' + copy('healthStaleTail');
    if (state === 'error') return copy('healthError');
    return copy('healthChecking');
  }

  function normalizeSearchPayload(payload) {
    var data = responseData(payload);
    var items = firstArray(payload);
    var pagination = data.pagination || payload.pagination || {};
    var total = pagination.total != null ? pagination.total : (data.total != null ? data.total : payload.total);
    if (typeof total !== 'number' || !Number.isSafeInteger(total) || total < items.length) throw new Error('public_search_payload_unavailable');
    var totalPages = Number(pagination.total_pages != null ? pagination.total_pages : (data.total_pages != null ? data.total_pages : payload.total_pages));
    var page = Number(pagination.page != null ? pagination.page : (data.page != null ? data.page : payload.page));
    var limit = Number(pagination.limit != null ? pagination.limit : (data.limit != null ? data.limit : payload.limit));
    return {
      items: items,
      total: Number.isFinite(total) ? total : items.length,
      totalPages: Number.isFinite(totalPages) && totalPages > 0 ? totalPages : Math.max(1, Math.ceil(total / (limit || SEARCH_PAGE_SIZE))),
      nextCursor: clean(data.next_cursor || payload.next_cursor),
      hasMore: Boolean(data.has_more != null ? data.has_more : payload.has_more),
      facets: data.facets || payload.facets || {},
      page: Number.isFinite(page) && page > 0 ? page : 1,
      limit: Number.isFinite(limit) && limit > 0 ? limit : SEARCH_PAGE_SIZE,
      verifiedAt: clean(data.verified_at || data.generated_at || payload.verified_at || payload.generated_at)
    };
  }

  function readMapCount(value) {
    if (
      typeof value !== 'number' &&
      typeof value !== 'string'
    ) return null;

    if (
      typeof value === 'string' &&
      !/^\d+$/.test(value.trim())
    ) return null;

    const count = Number(value);

    return Number.isSafeInteger(count) && count >= 0
      ? count
      : null;
  }

  function normalizeOpportunityMapPayload(payload) {

    var data = responseData(payload);
    var map = data.map && typeof data.map === 'object' && !Array.isArray(data.map) ? data.map : data;
    var aggregates = Array.isArray(map.aggregates)
      ? map.aggregates
      : Array.isArray(map.places)
        ? map.places
        : [];
    let discovery = readMapCount(map.discovery_count);

    let mapped = readMapCount(map.mapped_count);
    let unmapped = readMapCount(map.unmapped_count);
    return {
      discoveryCount: discovery,
      mappedCount: mapped,
      unmappedCount: unmapped,

      aggregates: aggregates.filter(function (row) {
        return row && typeof row === 'object' && clean(row.place_id);
      })
    };
  }

  function renderOpportunityMap(root, mapResult) {
    var zh = localeFamily() === 'zh';
    var status = root.querySelector('[data-gtender-map-status]');
    var discovery = root.querySelector('[data-gtender-map-discovery-count]');
    var mapped = root.querySelector('[data-gtender-map-mapped-count]');
    var unmapped = root.querySelector('[data-gtender-map-unmapped-count]');
    var places = root.querySelector('[data-gtender-map-places]');

    if (discovery) {
      discovery.textContent = mapResult.discoveryCount === null
        ? '—'
        : String(mapResult.discoveryCount);
    }

    if (mapped) {
      mapped.textContent = mapResult.mappedCount === null
        ? '—'
        : String(mapResult.mappedCount);
    }

    if (unmapped) {
      unmapped.textContent = mapResult.unmappedCount === null
        ? '—'
        : String(mapResult.unmappedCount);
    }

    if (status) {
      const countsKnown =
        mapResult.discoveryCount !== null &&
        mapResult.mappedCount !== null &&
        mapResult.unmappedCount !== null;

      if (!countsKnown) {
        status.textContent = zh
          ? '部分數量暫未提供；「—」不代表零。地圖只標示可確認的位置。'
          : 'Some counts are unavailable; “—” does not mean zero. Only confirmed locations are mapped.';
      } else if (mapResult.discoveryCount === 0) {
        status.textContent = zh
          ? '這次搜尋提供的招標數為零，可調整條件再試。這不代表整體市場沒有招標。'
          : 'This search reports zero tenders. Try different filters; this is not a market-wide count.';
      } else {
        status.textContent = zh
          ? '本次搜尋：' +
            mapResult.mappedCount + ' 個招標有已核實的地點關聯，' +
            mapResult.unmappedCount + ' 個尚無已核實的地點關聯。' +
            '只有地點提供有效座標時才會顯示地圖標記；以上並非整體市場數量。'
          : 'For this search: ' +
            mapResult.mappedCount + ' tenders have verified Place links; ' +
            mapResult.unmappedCount + ' have no verified Place link. ' +
            'Map pins require usable Place coordinates; these are not market-wide totals.';
      }
    }

    if (mapResult.mappedCount === null) {
      root.removeAttribute('data-gtender-map-state');
    } else {
      root.setAttribute(
        'data-gtender-map-state',
        mapResult.mappedCount > 0
          ? 'verified-relations'
          : 'no-verified-relations'
      );
    }

    if (!places) return;
    places.replaceChildren();

    mapResult.aggregates.forEach(function (aggregate) {
      var placeId = clean(aggregate.place_id);
      if (!placeId) return;
      var row = element('article', 'gtender-opportunity-map__place');
      row.setAttribute('data-gtender-map-place', placeId);
      row.appendChild(element('strong', 'gtender-opportunity-map__place-name', clean(aggregate.place_name) || placeId));

      const opportunityCount = readMapCount(
        aggregate.opportunity_count
      );

      const countLabel = opportunityCount === null
        ? (zh ? '招標數暫未提供' : 'Tender count unavailable')
        : (
          zh
            ? opportunityCount + ' 個招標'
            : opportunityCount +
              (opportunityCount === 1 ? ' tender' : ' tenders')
        );

      row.appendChild(element(
        'span',
        'gtender-opportunity-map__place-count',
        countLabel
      ));

      var categories = aggregate.category_counts && typeof aggregate.category_counts === 'object'
        ? Object.keys(aggregate.category_counts).filter(function (key) { return clean(key); }).slice(0, 3)
        : [];
      var themes = aggregate.service_theme_counts && typeof aggregate.service_theme_counts === 'object'
        ? Object.keys(aggregate.service_theme_counts).filter(function (key) { return clean(key); }).slice(0, 3)
        : [];
      var evidence = categories.map(categoryLabel).concat(themes.map(function (value) {
        return clean(value).replace(/[_-]+/g, ' ');
      })).filter(Boolean);
      if (evidence.length) row.appendChild(element('small', 'gtender-opportunity-map__place-meta', evidence.join(' · ')));
      places.appendChild(row);
    });

    if (!mapResult.aggregates.length) {
      places.appendChild(element(
        'p',
        'gtender-opportunity-map__empty',
        zh
          ? '這次結果暫未提供可顯示的位置。'
          : 'No map locations are available in this response.'
      ));
    }
  }

  function renderOpportunityMapError(root) {
    var zh = localeFamily() === 'zh';
    var status = root.querySelector('[data-gtender-map-status]');
    var places = root.querySelector('[data-gtender-map-places]');
    ['[data-gtender-map-discovery-count]', '[data-gtender-map-mapped-count]', '[data-gtender-map-unmapped-count]'].forEach(function (selector) {
      var node = root.querySelector(selector);
      if (node) node.textContent = '—';
    });
    if (status) status.textContent = zh
      ? '暫時未能載入招標位置，請稍後再試。'
      : 'Search regions could not be loaded. Please try again later.';
    if (places) places.replaceChildren();
    root.setAttribute('data-gtender-map-state', 'unavailable');
  }

  function setText(root, selector, value, fallback) {
    var node = root.querySelector(selector);
    if (node) node.textContent = clean(value) || fallback || '—';
  }

  function ensureDetailFact(dialog, key, label) {
    var selector = '[data-gtender-detail-' + key + ']';
    var current = dialog.querySelector(selector);
    if (current) {
      const wrapper = current.parentElement;
      const term = wrapper && wrapper.querySelector('dt');
      if (term) term.textContent = label;
      return current;
    }
    var secondaryFacts = /^(category|published)$/.test(key)
      ? dialog.querySelector('[data-gtender-secondary-facts]')
      : null;
    var facts = secondaryFacts || dialog.querySelector('.gtender-public-detail__facts');
    if (!facts) return null;
    var wrapper = document.createElement('div');
    var term = document.createElement('dt');
    var value = document.createElement('dd');
    term.textContent = label;
    value.setAttribute('data-gtender-detail-' + key, '');
    value.textContent = '—';
    wrapper.appendChild(term); wrapper.appendChild(value); facts.appendChild(wrapper);
    return value;
  }

  function detailSubject(item) {
    if (localeFamily() === 'zh') return clean(item && (item.subject_zh_hk || item.subject_en || item.title || item.name)) || copy('tenderDetail');
    return clean(item && (item.subject_en || item.subject_zh_hk || item.title || item.name)) || copy('tenderDetail');
  }

  function detailDepartment(item) {
    if (localeFamily() === 'zh') return clean(item && (item.issuing_department_zh_hk || item.requisitioning_department_zh_hk || item.issuing_department_en || item.requisitioning_department_en || item.organization || item.organizer || item.issuer));
    return clean(item && (item.issuing_department_en || item.requisitioning_department_en || item.issuing_department_zh_hk || item.requisitioning_department_zh_hk || item.organization || item.organizer || item.issuer));
  }

  function detailReference(item) { return clean(item && (item.tender_reference || item.raw_source_id || item.reference || item.reference_no)); }

  function clearContextualHelpers(dialog) {
    const host = dialog.querySelector('[data-gtender-contextual-helpers]');
    if (!host) return;

    host.hidden = true;
    host.replaceChildren();
  }

  function renderContextualHelpers(dialog, item) {
    clearContextualHelpers(dialog);

    const host = dialog.querySelector('[data-gtender-contextual-helpers]');
    if (!host || !item) return;

    const hasValues = (values) =>
      Array.isArray(values) &&
      values.some((value) =>
        typeof value === 'string' && clean(value).length > 0
      );

    const scopeProvided = hasValues(item.scope);
    const requirementsProvided = hasValues(item.required_capabilities);

    if (scopeProvided && requirementsProvided) return;

    const officialUrl = safeOfficialUrl(
      item.source_url || item.official_url || item.url
    );
    if (!officialUrl) return;

    const zh = localeFamily() === 'zh';
    const note = document.createElement('p');
    note.className = 'gtender-contextual-helpers__note';
    note.textContent = zh
      ? '目前資料未完整列出範疇或能力要求，請以官方文件核對。'
      : 'This response does not fully list scope or capability requirements. Confirm them in the official documents.';

    const link = document.createElement('a');
    link.className = 'lg-bento-card__action';
    link.href = officialUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = zh
      ? '核對官方招標文件'
      : 'Review official tender documents';

    host.append(note, link);
    host.hidden = false;
  }

  function renderDecisionFields(dialog, item) {
    const zh = localeFamily() === 'zh';
    const text = (selector, value) => {
      const node = dialog.querySelector(selector);
      if (node) node.textContent = value;
    };
    const notAnalysed = zh
      ? '招標文件分析結果尚未提供'
      : 'Tender document analysis is not available yet';

    text(
      '[data-gtender-decision-budget]',
      clean(item && item.budget_text) ||
        (zh ? '未披露' : 'Not disclosed')
    );

    const rawClosing = clean(item && item.closing_datetime_raw);
    let closingInstant = '';

    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(rawClosing)) {
      closingInstant = rawClosing.replace(' ', 'T') + '+08:00';
    }

    const closingMs = closingInstant ? Date.parse(closingInstant) : NaN;
    const remainingMs = closingMs - Date.now();
    const dateOnlyCountdown = getDeadlineBadgeInfo(clean(item && item.deadline));
    let countdown = dateOnlyCountdown
      ? dateOnlyCountdown.text + (dateOnlyCountdown.state === 'expired'
        ? ''
        : (zh ? ' · 未提供精確截止時間' : ' · exact closing time not provided'))
      : (zh ? '未提供截止日期' : 'Closing date not provided');

    if (Number.isFinite(closingMs)) {
      if (remainingMs <= 0) {
        countdown = zh ? '已到公告截止時間' : 'Notice closing time has passed';
      } else {
        const totalHours = Math.max(1, Math.ceil(remainingMs / 3600000));
        const days = Math.floor(totalHours / 24);
        const hours = totalHours % 24;
        if (days > 0) {
          countdown = zh
            ? `${days} 日${hours ? ` ${hours} 小時` : ''}後截止`
            : `Closes in ${days}d${hours ? ` ${hours}h` : ''}`;
        } else {
          countdown = zh ? `${totalHours} 小時後截止` : `Closes in ${totalHours}h`;
        }
      }
    }

    text('[data-gtender-decision-countdown]', countdown);

    const countdownNode = dialog.querySelector(
      '[data-gtender-decision-countdown]'
    );

    if (countdownNode) {
      const tone = !Number.isFinite(closingMs)
        ? 'unknown'
        : remainingMs <= 0
          ? 'expired'
          : remainingMs < 7 * 86400000
            ? 'urgent'
            : 'normal';

      countdownNode.setAttribute('data-countdown-tone', tone);
    }

    const scope = Array.isArray(item && item.scope)
      ? item.scope.filter((value) => typeof value === 'string')
          .map((value) => clean(value)).filter(Boolean)
      : [];

    const capabilities = Array.isArray(item && item.required_capabilities)
      ? item.required_capabilities
          .filter((value) => typeof value === 'string')
          .map((value) => clean(value)).filter(Boolean)
      : [];

    text(
      '[data-gtender-decision-scope]',
      scope.length
        ? scope.join(' · ')
        : (zh ? '目前回應未提供工作範圍，請查看招標文件'
              : 'Scope not provided in this response; review tender documents')
    );

    text(
      '[data-gtender-decision-requirements]',
      capabilities.length
        ? (zh ? '資料來源列出的能力要求（仍須核對招標文件）：'
              : 'Capabilities listed by the source; confirm against tender documents: ') +
          capabilities.join(' · ')
        : notAnalysed
    );

    text('[data-gtender-decision-risks]', notAnalysed);
    text('[data-gtender-decision-certificates]', notAnalysed);

    const indicators = item && item.source_indicators || {};
    const dates = [];
    if (rawClosing) {
      dates.push((zh ? '截止：' : 'Closing: ') + rawClosing +
        (zh ? '（香港時間）' : ' (Hong Kong time)'));
    }
    if (indicators.revised_closing_date === 'Y') {
      dates.push(zh ? '官方標記：截止日期曾修訂'
                    : 'Official flag: closing date revised');
    }
    if (indicators.new_addendum === 'Y') {
      dates.push(zh ? '官方標記：有新增補充文件'
                    : 'Official flag: new addendum');
    }
    text(
      '[data-gtender-decision-dates]',
      dates.join(' · ') || (zh ? '未提供' : 'Not provided')
    );

    const content = dialog.querySelector('[data-gtender-decision-content]');
    if (content) content.hidden = false;
  }

  function composeDecisionPresentation(root, dialog, item) {
    const zh = localeFamily() === 'zh';
    const tenderId = clean(item && (item.id || item.tender_id)) ||
      clean(root.getAttribute('data-gtender-active-detail-id'));

    const identity = dialog.querySelector('[data-gtender-analysis-tender-id]');
    if (identity) identity.textContent = tenderId ||
      (zh ? '未提供' : 'Not provided');

    const fields = [
      ['scope', true],
      ['requirements', true],
      ['risks', false],
      ['certificates', false],
      ['dates', true]
    ];

    fields.forEach(([key, hasNoticeProjection]) => {
      const host = dialog.querySelector('[data-gtender-decision-' + key + ']');
      if (!host) return;

      const projectedText = host.textContent;
      host.replaceChildren();

      const createLayer = (className, label, value) => {
        const layer = document.createElement('div');
        layer.className = className;
        const heading = document.createElement('span');
        heading.className = 'gtender-analysis-layer__label';
        heading.textContent = label;
        const body = document.createElement('p');
        body.textContent = value;
        layer.append(heading, body);
        host.appendChild(layer);
      };

      createLayer(
        'gtender-analysis-layer gtender-analysis-layer--source',
        zh ? '公告／API 資料 · 須核對原文件' : 'Notice / API data · Check original documents',
        hasNoticeProjection ? projectedText : (zh ? '目前未呈現來源證據，不能判定沒有此項要求' : 'Source evidence is not shown; absence of a requirement cannot be inferred')
      );
      host.setAttribute('data-model-interpretation-state', 'not-loaded');
    });
  }

  function memberDetailUnlocked() {
    try {
      var session = window.LittleGWebSession;
      var current = session && typeof session.getState === 'function' ? session.getState() : null;
      return Boolean(current && current.status === 'authenticated');
    } catch (_) { return false; }
  }

  function syncMemberDetailAccess(root, dialog) {
    if (!dialog) return;
    var unlocked = memberDetailUnlocked();
    dialog.setAttribute('data-gtender-member-access', unlocked ? 'member' : 'locked');
    dialog.querySelectorAll('[data-gtender-member-section]').forEach(function (section) {
      section.setAttribute('data-member-locked', String(!unlocked));
      Array.prototype.forEach.call(section.children, function (child) {
        if (child.hasAttribute('data-gtender-member-gate')) return;
        if (!unlocked) {
          child.setAttribute('aria-hidden', 'true');
          try { child.inert = true; } catch (_) {}
        } else {
          child.removeAttribute('aria-hidden');
          try { child.inert = false; } catch (_) {}
        }
      });
    });
    dialog.querySelectorAll('[data-gtender-member-gate]').forEach(function (gate) { gate.hidden = unlocked; });
    if (root) root.setAttribute('data-gtender-member-access', unlocked ? 'member' : 'locked');
  }

  function renderDetail(root, item) {
    var state = stateByRoot.get(root) || { verifiedAt: '' };
    var dialog = root.querySelector('[data-gtender-public-detail]');
    if (!dialog) return;
    renderDecisionFields(dialog, item);
    renderContextualHelpers(dialog, item);
    composeDecisionPresentation(root, dialog, item);
    syncMemberDetailAccess(root, dialog);
    ensureDetailFact(dialog, 'source', copy('source'));
    ensureDetailFact(dialog, 'verified', copy('verifiedAsOf'));
    ensureDetailFact(dialog, 'category', copy('category'));
    ensureDetailFact(dialog, 'published', copy('postedDate'));
    var published = clean(item && (item.issue_datetime_raw || item.published_at));
    var publishedFact = dialog.querySelector('[data-gtender-detail-published]');
    publishedFact.textContent = published;
    publishedFact.parentElement.hidden = !published;
    var provenance = dialog.querySelector('[data-gtender-detail-provenance]');
    if (provenance) {
      const verified = dialog.querySelector('[data-gtender-detail-verified]');
      if (verified) provenance.appendChild(verified.parentElement);
    }
    var referenceFact = dialog.querySelector('[data-gtender-detail-reference]').parentElement;
    var categoryFact = dialog.querySelector('[data-gtender-detail-category]').parentElement;
    referenceFact.after(categoryFact);
    var summarySection = dialog.querySelector('[data-gtender-detail-summary-section]');
    var summary = clean(item && (item.summary || item.description));
    if (summarySection) {
      var equivalent = function (text) { return normalized(text).replace(/[\s.,，。:：;；!?！？]+/g, ''); };
      summarySection.hidden = !summary || equivalent(summary) === equivalent(detailSubject(item));
      setText(summarySection, '[data-gtender-detail-summary]', summary, '');
    }

    var lifecycle = lifecycleInfo(item);

    setText(dialog, '[data-gtender-detail-subject]', detailSubject(item), copy('tenderDetail'));
    setText(dialog, '[data-gtender-detail-reference]', detailReference(item), copy('notProvided'));
    setText(dialog, '[data-gtender-detail-department]', detailDepartment(item), copy('notProvided'));
    setText(dialog, '[data-gtender-detail-deadline]', item && (item.closing_datetime_raw || item.deadline), copy('notProvided'));
    setText(dialog, '[data-gtender-detail-state]', lifecycle.label, copy('notProvided'));
    const verifiedText = formatAsOf(
      recordVerifiedAt(item, state.verifiedAt)
    );

    setText(
      dialog,
      '[data-gtender-detail-verified]',
      verifiedText,
      copy('notProvided')
    );

    const headerVerified = dialog.querySelector(
      '[data-gtender-header-verified]'
    );

    if (headerVerified) {
      headerVerified.textContent = verifiedText;
      headerVerified.parentElement.hidden = !verifiedText;
    }
    setText(dialog, '[data-gtender-detail-category]', categoryLabel(item && item.category), copy('notClassified'));

    var statusNode = dialog.querySelector('[data-gtender-detail-state]');
    if (statusNode) {
      statusNode.setAttribute(
        'data-status-tone',
        lifecycle.tone
      );

      if (lifecycle.key) {
        statusNode.setAttribute(
          'data-gtender-lifecycle-status',
          lifecycle.key
        );
      } else {
        statusNode.removeAttribute(
          'data-gtender-lifecycle-status'
        );
      }
    }

    var official = dialog.querySelector('[data-gtender-detail-official]');
    var officialUrl = safeOfficialUrl(item && (item.source_url || item.official_url || item.url));

    const briefButton = dialog.querySelector('[data-gtender-detail-brief]');
    const suppliersButton = dialog.querySelector('[data-gtender-detail-suppliers]');
    const lowAltitudeButton = dialog.querySelector('[data-gtender-detail-low-altitude]');
    if (lowAltitudeButton) {
      lowAltitudeButton.hidden = true;
      lowAltitudeButton.onclick = null;
    }
    const tenderId = clean(item && (item.id || item.tender_id)) ||
      clean(root.getAttribute('data-gtender-active-detail-id'));
    let briefDestination = null;
    let supplierDestination = null;

    try {
      const configuredSupplierUrl = root.getAttribute('data-brief-workspace-url');
      if (!configuredSupplierUrl) throw new Error('Missing Supplier Network destination');

      const destination = new URL(configuredSupplierUrl, window.location.origin);
      const destinationPath = destination.pathname.replace(/\/+$/, '');
      if (
        destination.origin !== window.location.origin ||
        !destinationPath.endsWith('/pages/gcitypartners-dashboard')
      ) {
        throw new Error('Invalid Supplier Network destination');
      }

      destination.searchParams.set('source', 'gtender');
      destination.searchParams.set('workspace', 'partners');
      supplierDestination = destination;
    } catch (_) {
      supplierDestination = null;
    }

    try {
      const configuredUrl = root.getAttribute('data-partner-join-url');
      if (!configuredUrl) throw new Error('Missing brief destination');

      const destination = new URL(configuredUrl, window.location.origin);
      if (
        destination.origin !== window.location.origin ||
        destination.searchParams.get('intent') !== 'professional-review'
      ) {
        throw new Error('Invalid brief destination');
      }

      destination.searchParams.set('source', 'gtender');
      destination.searchParams.set('stage', 'intake');
      destination.searchParams.set('delivery_type', 'manual-review');
      destination.searchParams.delete('dashboard_handoff');
      destination.hash = 'gcp-brief-form';
      briefDestination = destination;

      const workspacePath = root.getAttribute('data-brief-workspace-url');
      if (workspacePath) {
        const workspace = new URL(workspacePath, window.location.origin);
        if (workspace.origin !== window.location.origin) {
          throw new Error('Invalid workspace destination');
        }
        workspace.searchParams.set('source', 'gtender');
        workspace.searchParams.set('intent', 'professional-review');
        briefDestination = workspace;
      }
    } catch (_) {
      briefDestination = null;
    }

    let prepareTenderHandoff = null;
    if (briefButton) {
      briefButton.hidden =
        !briefDestination || !SHARED_TENDER_ID_RE.test(tenderId);
      briefButton.onclick = null;

      if (!briefButton.hidden || supplierDestination) {
        prepareTenderHandoff = (destination) => {
          if (
            clean(root.getAttribute('data-gtender-active-detail-id')) !== tenderId
          ) return;

          const locale = clean(
            root.getAttribute('data-locale') ||
            document.documentElement.lang
          ).toLowerCase();
          const isZh = /^zh/i.test(locale);
          const isZhCN = locale === 'zh-cn';
          const tenderTitle = clean(detailSubject(item)).slice(0, 500);
          const reference = clean(detailReference(item)).slice(0, 240);
          const detailUrl = gtenderTenderUrl(tenderId);
          const lines = [
            isZh ? '招標需求資料' : 'Tender brief context',
            (isZh ? '招標：' : 'Tender: ') + tenderTitle,
            (isZh ? '識別碼：' : 'Tender ID: ') + tenderId
          ];

          if (reference) {
            lines.push((isZh ? '公告編號：' : 'Reference: ') + reference);
          }
          if (detailUrl) {
            lines.push((isZh ? 'GTender 詳情：' : 'GTender detail: ') + detailUrl);
          }
          if (officialUrl) {
            lines.push((isZh ? '官方來源：' : 'Official source: ') + officialUrl);
          }

          const description = lines.join('\n');
          const isSupplierHandoff =
            destination.searchParams.get('workspace') === 'partners';
          if (description.length > 1200) {
            setDetailStatus(root, isZh
              ? '招標資料超出需求欄位長度，請手動整理名稱與來源連結。'
              : 'Tender context exceeds the brief field limit. Add the title and source links manually.');
            return;
          }

          try {
            const handoffKey = 'gcp_dashboard_brief_handoff_v1';
            const existingRaw = window.sessionStorage.getItem(handoffKey);

            if (existingRaw) {
              const existing = JSON.parse(existingRaw);
              const age = Date.now() - Number(existing && existing.created_at);
              const sameTender =
                existing &&
                existing.version === 1 &&
                existing.source === 'gtender' &&
                existing.tender_context &&
                existing.tender_context.id === tenderId &&
                Number.isFinite(age) &&
                age >= 0 &&
                age <= 30 * 60 * 1000;
              const replaceableSupplierHandoff =
                isSupplierHandoff &&
                existing &&
                existing.version === 1 &&
                existing.source === 'gtender' &&
                existing.handoff_purpose === 'supplier-search';

              if (!sameTender && !replaceableSupplierHandoff) {
                setDetailStatus(root, isZh
                  ? (isZhCN
                      ? '此标签页已有其他需求或过期资料，未覆盖。请先处理原需求后再继续。'
                      : '此分頁已有其他需求或過期資料，未覆蓋。請先處理原需求後再繼續。')
                  : 'This tab contains another request or expired details. Nothing was overwritten; resolve the existing request first.');
                return;
              }

              if (sameTender) {
                window.location.assign(destination.href);
                return;
              }
            }

            window.sessionStorage.setItem(
              'gcp_dashboard_brief_handoff_v1',
              JSON.stringify({
                version: 1,
                source: 'gtender',
                handoff_purpose: isSupplierHandoff ? 'supplier-search' : 'brief',
                created_at: Date.now(),
                project_location: '',
                description,
                tender_context: {
                  id: tenderId,
                  title: tenderTitle,
                  reference,
                  detail_url: detailUrl,
                  official_url: officialUrl
                }
              })
            );
          } catch (_) {
            setDetailStatus(root, isZh
              ? '瀏覽器無法暫存資料。請複製招標名稱與來源連結後，再到下一頁填寫。'
              : 'Browser storage is unavailable. Copy the tender title and source links before continuing.');
            return;
          }

          window.location.assign(destination.href);
        };

        briefButton.onclick = () => prepareTenderHandoff(briefDestination);

        if (lowAltitudeButton) {
          try {
            const configuredLowAltitudeUrl =
              root.getAttribute('data-low-altitude-workspace-url');
            if (!configuredLowAltitudeUrl) {
              throw new Error('Missing low-altitude destination');
            }

            const lowAltitudeDestination = new URL(
              configuredLowAltitudeUrl,
              window.location.origin
            );

            if (
              lowAltitudeDestination.origin !== window.location.origin ||
              !/\/pages\/low-altitude-economy\/?$/.test(
                lowAltitudeDestination.pathname
              )
            ) throw new Error('Invalid low-altitude destination');

            lowAltitudeDestination.searchParams.set('source', 'gtender');
            lowAltitudeDestination.searchParams.set(
              'intent',
              'professional-review'
            );
            lowAltitudeDestination.searchParams.set('tender', tenderId);
            lowAltitudeDestination.hash = '';

            lowAltitudeButton.hidden = true;
            lowAltitudeButton.onclick = null;
          } catch (_) {
            lowAltitudeButton.hidden = true;
            lowAltitudeButton.onclick = null;
          }
        }
      }
    }
    if (suppliersButton) {
      suppliersButton.hidden =
        !supplierDestination ||
        !prepareTenderHandoff ||
        !SHARED_TENDER_ID_RE.test(tenderId);
      suppliersButton.onclick = null;
      if (!suppliersButton.hidden) {
        suppliersButton.onclick = () => prepareTenderHandoff(supplierDestination);
      }
    }
    if (!official) return;
    var sourceFact = dialog.querySelector('[data-gtender-detail-source]');
    var legacySourceLine = dialog.querySelector('[data-gtender-detail-source-line]');
    if (legacySourceLine) legacySourceLine.remove();

    official.classList.remove(
      'gtender-partner-entry__button',
      'gtender-partner-entry__button--primary'
    );

    const sourceLabel = sourceIdentity(item) || copy('officialSource');
    // The official link is a permanent icon in the sticky toolbar.
    // Keep its SVG and identity intact rather than moving it into the facts.
    official.title = sourceLabel;
    official.setAttribute('aria-label',
      (localeFamily() === 'zh' ? '開啟官方公告：' : 'Open official notice: ') + sourceLabel);

    if (officialUrl) {
      official.href = officialUrl;
      official.hidden = false;
    } else {
      official.removeAttribute('href');
      official.hidden = true;
    }

    if (sourceFact) {
      sourceFact.textContent = sourceLabel;
      if (sourceFact.parentElement) {
        sourceFact.parentElement.hidden = false;
      }
    }
  }

  function setDetailStatus(root, text) {
    var dialog = root.querySelector('[data-gtender-public-detail]');
    var node = dialog && dialog.querySelector('[data-gtender-detail-status]');
    if (node) node.textContent = text || '';
  }

  function resetDetailDrag(dialog) {
    if (!dialog) return;
    dialog.style.removeProperty('transform');
    dialog.removeAttribute('data-gtender-dragging');
  }

  function detailFocusableNodes(dialog) {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])'),
      function (node) {
        for (var parent = node; parent && parent !== dialog; parent = parent.parentElement) {
          if (parent.hidden || parent.inert || parent.getAttribute('aria-hidden') === 'true') return false;
        }
        return true;
      }
    );
  }

  function finalizeDetailClose(root, dialog) {
    if (!dialog) return;
    clearContextualHelpers(dialog);
    resetDetailDrag(dialog);
    dialog.removeAttribute('data-gtender-detail-visible');
    dialog.hidden = true;
    if (root) root.removeAttribute('data-gtender-detail-visible');
    document.documentElement.classList.remove('gtender-detail-open');
    var state = root ? stateByRoot.get(root) : null;
    var trigger = state && state.detailTrigger;
    if (state) {
      state.detailTrigger = null;
      if (state.detailController) {
        state.detailController.abort();
        state.detailController = null;
      }
    }
    if (trigger && trigger.isConnected && typeof trigger.focus === 'function') {
      window.setTimeout(function () {
        try { trigger.focus({ preventScroll: true }); }
        catch (_error) { try { trigger.focus(); } catch (_) {} }
      }, 0);
    }
  }

  function syncDetailPresentation(root, dialog) {
    const state = stateByRoot.get(root);
    const desktop = Boolean(
      window.matchMedia &&
      window.matchMedia('(min-width: 1024px)').matches &&
      dialog.closest('[data-gtender-public-preview-column]')
    );

    let modal =
      dialog.getAttribute('data-gtender-detail-presentation') === 'modal';

    try {
      modal = dialog.matches(':modal');
    } catch (_) {}

    if (
      dialog.open &&
      modal !== !desktop &&
      typeof dialog.close === 'function'
    ) {
      if (state) {
        state.detailPresentationCloses =
          (state.detailPresentationCloses || 0) + 1;
      }

      try {
        dialog.close();
      } catch (_) {
        if (state) state.detailPresentationCloses -= 1;
        return;
      }
    }

    dialog.setAttribute(
      'data-gtender-detail-presentation',
      desktop ? 'inline' : 'modal'
    );
    dialog.setAttribute('aria-modal', desktop ? 'false' : 'true');

    document.documentElement.classList.toggle(
      'gtender-detail-open',
      !desktop
    );

    if (!dialog.open) {
      try {
        if (desktop && typeof dialog.show === 'function') {
          dialog.show();
        } else if (!desktop && typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      } catch (_) {
        dialog.setAttribute('open', '');
      }
    }
  }

  function resetInlineDetailScroll(root, dialog) {
    if (!root || !dialog) return;
    if (root.getAttribute('data-gtender-view-mode') !== 'list') return;
    if (
      dialog.getAttribute('data-gtender-detail-presentation') !== 'inline'
    ) return;

    const preview = dialog.closest(
      '[data-gtender-public-preview-column]'
    );

    if (preview) {
      preview.scrollTop = 0;
    }
  }

  function showDialog(root, dialog) {
    if (!dialog) return;

    resetDetailDrag(dialog);
    dialog.hidden = false;
    dialog.setAttribute('data-gtender-detail-visible', 'true');

    if (root) {
      root.setAttribute('data-gtender-detail-visible', 'true');
    }

    syncDetailPresentation(root, dialog);
    resetInlineDetailScroll(root, dialog);

    const title = dialog.querySelector('[data-gtender-detail-subject]');    if (title) {
      title.setAttribute('tabindex', '-1');
      try {
        title.focus({ preventScroll: true });
      } catch (_) {
        title.focus();
      }
    }
  }

  function closeDialog(root) {
    var dialog = root.querySelector('[data-gtender-public-detail]');
    if (!dialog) return;
    try {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    } catch (_error) { dialog.removeAttribute('open'); }
    finalizeDetailClose(root, dialog);
  }

  async function openDetail(root, listItem, trigger) {
    const state = stateByRoot.get(root);
    const id = clean(listItem && (listItem.id || listItem.tender_id));
    const dialog = root.querySelector('[data-gtender-public-detail]');
    if (!state || !state.active || !id || !dialog) return;

    state.detailRequestSequence = (state.detailRequestSequence || 0) + 1;
    const sequence = state.detailRequestSequence;
    if (state.detailController) state.detailController.abort();
    const detailController = typeof AbortController === 'function' ? new AbortController() : null;
    state.detailController = detailController;
    let detailTimeout = null;

    root.setAttribute('data-gtender-active-detail-id', id);
    state.detailTrigger = trigger || null;

    function isCurrentDetail() {
      return state.active &&
        stateByRoot.get(root) === state &&
        sequence === state.detailRequestSequence &&
        !dialog.hidden &&
        root.getAttribute('data-gtender-active-detail-id') === id;
    }

    dialog.querySelectorAll('details').forEach((node) => {
      node.open = false;
    });

    function clearUnverifiedDetail(message) {
      clearContextualHelpers(dialog);

      const headerVerified = dialog.querySelector(
        '[data-gtender-header-verified]'
      );

      if (headerVerified) {
        headerVerified.textContent = '';
        headerVerified.parentElement.hidden = true;
      }

      const title = dialog.querySelector('[data-gtender-detail-subject]');
      if (title) title.textContent = message;

      dialog.querySelectorAll('dd').forEach((node) => {
        if (node.closest('[data-gtender-decision-content]')) return;

        const countdown = node.querySelector(
          '[data-gtender-decision-countdown]'
        );
        const deadline = node.querySelector(
          '[data-gtender-detail-deadline]'
        );

        if (countdown || deadline) {
          if (countdown) {
            countdown.textContent = '';
            countdown.removeAttribute('data-countdown-tone');
          }
          if (deadline) deadline.textContent = '';
          return;
        }

        const official = node.querySelector(
          '[data-gtender-detail-official]'
        );

        if (official) {
          official.removeAttribute('href');
          official.removeAttribute('title');
          official.textContent = '';
          official.hidden = true;
          node.replaceChildren(official);
          return;
        }

        node.textContent = '';
      });

      const summary = dialog.querySelector('[data-gtender-detail-summary]');
      if (summary) summary.textContent = '';

      dialog.querySelectorAll(
        '.gtender-public-detail__facts, ' +
        '[data-gtender-detail-summary-section], ' +
        '[data-gtender-secondary-facts-section], ' +
        '[data-gtender-detail-provenance], ' +
        '[data-gtender-decision-content], ' +
        '.gtender-public-detail__actions, ' +
        '[data-gtender-detail-utility-actions]'
      ).forEach((node) => {
        node.hidden = true;
      });

      const official = dialog.querySelector('[data-gtender-detail-official]');
      if (official) {
        official.removeAttribute('href');
        official.hidden = true;
      }

      dialog.querySelectorAll(
        '[data-gtender-detail-brief], [data-gtender-detail-low-altitude], ' +
        '[data-gtender-detail-suppliers]'
      ).forEach((button) => {
        button.onclick = null;
        button.hidden = true;
      });
    }

    clearUnverifiedDetail(copy('loadingDetail'));
    showDialog(root, dialog);
    setDetailStatus(root, copy('loadingDetail'));

    try {
      const url = attachSourceClient(canonicalPublicEndpoint(
        root.getAttribute('data-tender-detail-endpoint'),
        DETAIL_FALLBACK
      ));
      url.searchParams.set('id', id);

      const fetchOptions = {
        method: 'GET',
        credentials: 'omit',
        headers: { Accept: 'application/json' }
      };
      if (detailController) fetchOptions.signal = detailController.signal;

      const detailRequest = fetch(url.toString(), fetchOptions);
      const timeoutRequest = new Promise(function (_, reject) {
        detailTimeout = window.setTimeout(function () {
          if (detailController) detailController.abort();
          const error = new Error('Tender detail request timed out.');
          error.code = 'gtender_detail_timeout';
          reject(error);
        }, DETAIL_REQUEST_TIMEOUT_MS);
      });
      const response = await Promise.race([detailRequest, timeoutRequest]);
      const payload = await response.json();
      if (!isCurrentDetail()) return;

      const item = detailItem(payload);
      if (!response.ok || payload.ok === false || !item) {
        throw new Error('detail_unavailable');
      }

      dialog.querySelectorAll(
        '.gtender-public-detail__facts, ' +
        '[data-gtender-secondary-facts-section], ' +
        '[data-gtender-detail-provenance], ' +
        '.gtender-public-detail__actions, ' +
        '[data-gtender-detail-utility-actions]'
      ).forEach((node) => {
        node.hidden = false;
      });

      renderDetail(root, item);
      setDetailStatus(root, '');

      resetInlineDetailScroll(root, dialog);

      window.requestAnimationFrame(() => {
        if (isCurrentDetail()) {
          resetInlineDetailScroll(root, dialog);
        }
      });
    } catch (_) {
      if (isCurrentDetail()) {
        clearUnverifiedDetail(copy('detailUnavailable'));
        root.removeAttribute('data-gtender-active-detail-id');
        setDetailStatus(root, copy('detailUnavailable'));
      }
    } finally {
      if (detailTimeout !== null) window.clearTimeout(detailTimeout);
      if (state.detailController === detailController) state.detailController = null;
    }
  }

  var INSTITUTION_LABELS = [
    ['HKUST', '科大', 'The Hong Kong University of Science and Technology', '香港科技大學'],
    ['HKMU', '都大', 'Hong Kong Metropolitan University', '香港都會大學'],
    ['GLD', '物流署', 'Government Logistics Department', '政府物流服務署', 'HKSAR GLD', '香港特別行政區政府物流服務署'],
    ['ArchSD', '建築署', 'Architectural Services Department', '香港特別行政區建築署'],
    ['AFCD', '漁護署', 'Agriculture, Fisheries and Conservation Department', '漁農自然護理署'],
    ['EPD', '環保署', 'Environmental Protection Department', '環境保護署'],
    ['EDB', '教育局', 'Education Bureau', '教育局'],
    ['CSD', '懲教署', 'Correctional Services Department', '懲教署'],
    ['GFS', '政府飛行服務隊', 'Government Flying Service', '政府飛行服務隊'],
    ['HKO', '天文台', 'Hong Kong Observatory', '香港天文台'],
    ['WSD', '水務署', 'Water Supplies Department', '水務署'],
    ['MD', '海事處', 'Marine Department', '海事處'],
    ['DH', '衞生署', 'Department of Health', '衞生署'],
    ['ImmD', '入境處', 'Immigration Department', '入境事務處'],
    ['ISD', '政府新聞處', 'Information Services Department', '政府新聞處'],
    ['HKPF', '警務處', 'Hong Kong Police Force', '香港警務處'],
    ['HKMA', '金管局', 'Hong Kong Monetary Authority', '香港金融管理局'],
    ['CEDD', '土木工程拓展署', 'Civil Engineering and Development Department', '土木工程拓展署'],
    ['SWD', '社會福利署', 'Social Welfare Department', '社會福利署'],
    ['IRD', '稅務局', 'Inland Revenue Department', '稅務局'],
    ['TD', '運輸署', 'Transport Department', '運輸署'],
    ['DEVB (WB)', '發展局（工務科）', 'Development Bureau (Works Branch)', '發展局（工務科）'],
    ['HKP', '香港郵政', 'Hongkong Post', '香港郵政', 'Hong Kong Post'],
    ['DoJ', '律政司', 'Department of Justice', '律政司'],
    ['LCSD', '康文署', 'Leisure and Cultural Services Department', '康樂及文化事務署'],
    ['FEHD', '食環署', 'Food and Environmental Hygiene Department', '食物環境衞生署'],
    ['DPO', '數字辦', 'Digital Policy Office', '數字政策辦公室'],
    ['JUD', '司法機構', 'Judiciary', '司法機構'],
    ['BD', '屋宇署', 'Buildings Department', '屋宇署'],
    ['EMSTF', '機電工程營運基金', 'Electrical and Mechanical Services Trading Fund', '機電工程營運基金', 'Electrical & Mechanical Services Trading Fund']
  ];

  function institutionMatch(value) {
    var name = clean(value).toLowerCase().replace(/^the\s+/, '');
    return INSTITUTION_LABELS.find(function (labels) {
      return labels.some(function (label) { return label.toLowerCase().replace(/^the\s+/, '') === name; });
    });
  }

  function institutionLabel(value) {
    var labels = institutionMatch(value);
    return labels ? labels[localeFamily() === 'zh' ? 1 : 0] : value;
  }

 function buildInsightRows(item) {
    var rows = element('div', 'gtender-card__insights');
    rows.setAttribute('data-gtender-card-insights', '');
    var record = item && typeof item === 'object' ? item : {};
    var zh = localeFamily() === 'zh';

    var explanation = record.match_explanation && typeof record.match_explanation === 'object' ? record.match_explanation : null;
    var reasons = explanation && Array.isArray(explanation.reasons)
      ? explanation.reasons.map(function (value) { return clean(value); }).filter(Boolean)
      : [];
    if (reasons.length) {
      var matchRow = element('p', 'gtender-card__date gtender-card__date--match');
      matchRow.appendChild(element('span', 'gtender-card__date-label', copy('matchLabel')));
      matchRow.appendChild(element('span', 'gtender-card__date-value', reasons.join(zh ? '；' : '; ')));
      rows.appendChild(matchRow);
    }

    var requirements = Array.isArray(record.required_capabilities)
      ? record.required_capabilities.map(function (value) { return clean(value); }).filter(Boolean)
      : [];
    var requirementsRow = element('p', 'gtender-card__date');
    requirementsRow.appendChild(element('span', 'gtender-card__date-label', copy('officialRequirements')));
    requirementsRow.appendChild(element('span', 'gtender-card__date-value', requirements.length ? requirements.join(zh ? '、' : ', ') : copy('requirementsMissing')));
    rows.appendChild(requirementsRow);

    var region = clean(record.region);
    var locationRow = element('p', 'gtender-card__date');
    locationRow.appendChild(element('span', 'gtender-card__date-label', copy('locationLabel')));
    locationRow.appendChild(element('span', 'gtender-card__date-value', region === 'hong-kong' ? copy('regionHongKong') : region || copy('locationPending')));
    rows.appendChild(locationRow);

    var nextAction = clean(record.recommended_next_action);
    if (nextAction) {
      var nextRow = element('p', 'gtender-card__date');
      nextRow.appendChild(element('span', 'gtender-card__date-label', copy('nextStepLabel')));
      nextRow.appendChild(element('span', 'gtender-card__date-value', nextAction));
      rows.appendChild(nextRow);
    }

    return rows;
  }

  function renderTender(root, item) {    var card = element('article', 'gtender-partner-entry__card');
    var title = detailSubject(item) || copy('publicTender');
      var org = detailDepartment(item);
    var id = clean(item && (item.id || item.tender_id));
    var officialUrl = safeOfficialUrl(item && (item.official_url || item.source_url || item.url));
    var shareUrl = gtenderTenderUrl(id);
    var headerRow = element('div', 'gtender-card__header-row');
    var badges = element('div', 'gtender-card__badges');
    var lifecycle = lifecycleInfo(item);

    const categoryText = categoryLabel(item && item.category);
    const categoryKey = clean(item && item.category)
      .toLowerCase()
      .replace(/[\s_]+/g, '-');

    const shortCategoryLabels = {
      'other-government-services':
        localeFamily() === 'zh' ? '政府服務' : 'Gov',
      'digital-it':
        localeFamily() === 'zh' ? '資訊科技' : 'IT'
    };

    const fullCategoryText = categoryText || copy('notClassified');
    const shortCategoryText =
      shortCategoryLabels[categoryKey] || fullCategoryText;

    const categoryBadge = element(
      'span',
      'gtender-card__badge gtender-card__badge--category',
      shortCategoryText
    );
    categoryBadge.title = fullCategoryText;
    categoryBadge.setAttribute('aria-label', fullCategoryText);
    badges.appendChild(categoryBadge);

    if (org) {
      var departmentBadge = element('span', 'gtender-card__badge gtender-card__badge--department', institutionLabel(org));
      var labels = institutionMatch(org);
      departmentBadge.title = labels ? labels[localeFamily() === 'zh' ? 3 : 2] : org;
      departmentBadge.setAttribute('aria-label', departmentBadge.title);
      badges.appendChild(departmentBadge);
    }

    if (lifecycle.key) {
      var lifecycleBadge = element(
        'span',
        'gtender-card__badge ' +
          'gtender-card__badge--status ' +
          'gtender-card__badge--status-' +
          lifecycle.tone,
        lifecycle.label
      );

      lifecycleBadge.setAttribute(
        'data-gtender-lifecycle-status',
        lifecycle.key
      );

      lifecycleBadge.setAttribute(
        'data-status-tone',
        lifecycle.tone
      );

      badges.appendChild(lifecycleBadge);
    }

    let deadlineBadge = null;
    const countdownAllowed =
      lifecycle.key === 'open' ||
      lifecycle.key === 'closing' ||
      lifecycle.key === 'deadline-passed';

    const countdownDeadline = clean(
      item && (item.closing_datetime_raw || item.deadline)
    );

    if (countdownAllowed && countdownDeadline) {
      const badgeInfo = getDeadlineBadgeInfo(countdownDeadline);

      if (badgeInfo) {
        deadlineBadge = element(
          'span',
          'gtender-card__badge gtender-card__badge--deadline gtender-card__badge--' + badgeInfo.state,
          badgeInfo.text
        );
      }
    }
    headerRow.appendChild(badges);
    card.appendChild(headerRow);
    const titleNode = element(
      id ? 'button' : 'strong',
      'gtender-card__title',
      title
    );

    if (id) {
      titleNode.type = 'button';
      titleNode.setAttribute('data-gtender-detail-open', id);
      titleNode.setAttribute('aria-haspopup', 'dialog');

      const detailDialog = root.querySelector(
        '[data-gtender-public-detail]'
      );

      if (detailDialog && detailDialog.id) {
        titleNode.setAttribute('aria-controls', detailDialog.id);
      }
    }

    card.appendChild(titleNode);

    const issuer = element(
      'p',
      'gtender-card__issuer',
      institutionLabel(org) || copy('notProvided')
    );

    if (org) {
      const labels = institutionMatch(org);
      const fullIssuer = labels
        ? labels[localeFamily() === 'zh' ? 3 : 2]
        : org;

      issuer.title = fullIssuer;
      issuer.setAttribute('aria-label', fullIssuer);
    }

    card.appendChild(issuer);


    var timing = element('div', 'gtender-card__timing');
    timing.setAttribute('data-gtender-card-timing', '');
    if (deadlineBadge) timing.appendChild(deadlineBadge);
    var closing = officialDateText(item && (item.closing_datetime_raw || item.deadline));
    closing = closing.replace(/\s*\(Hong Kong time\)$/, '').replace(/\s*（香港時間）$/, '');
    if (closing) {
      var closingRow = element('p', 'gtender-card__date gtender-card__date--closing');
      closingRow.appendChild(element('span', 'gtender-card__date-label', copy('cardClosing')));
      var parts = closing.match(/^(\d{2}\/\d{2}\/\d{4}),?\s+(\d{2}:\d{2})$/);
      if (parts) {
        closingRow.appendChild(element('span', 'gtender-card__date-day', parts[1] + ' '));
        closingRow.appendChild(element('span', 'gtender-card__date-time', parts[2]));
      } else closingRow.appendChild(element('span', 'gtender-card__date-value', closing));
      timing.appendChild(closingRow);
    }
    const budgetText = clean(item && item.budget_text);
    const budget = element(
      'span',
      'gtender-feed-budget',
      budgetText
        ? (copy('budgetPrefix')) + budgetText
        : (copy('budgetMissing'))
    );
    budget.classList.toggle(
      'gtender-feed-budget--undisclosed',
      !budgetText
    );
    timing.appendChild(budget);


   card.appendChild(timing);

    card.appendChild(buildInsightRows(item));

    var actionRow = element('div', 'gtender-card__action-row');
    if (id) {
      var detailButton = element('button', 'gtender-partner-entry__button gtender-partner-entry__button--primary', copy('viewDetails'));
      detailButton.type = 'button';
      detailButton.setAttribute('data-gtender-detail-open', id);
      detailButton.setAttribute('aria-haspopup', 'dialog');
      actionRow.appendChild(detailButton);
    }
    if (officialUrl) {
      var link = element('a', 'gtender-partner-entry__button', copy('viewOfficial'));
      link.href = officialUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.title = localeFamily() === 'zh' ? '請以官方公告及招標文件確認要求' : 'Verify requirements in the official tender documents';
      actionRow.appendChild(link);
    }
    if (shareUrl && title) {
      var shareButton = element('button', 'gtender-card__share', copy('share'));
      shareButton.type = 'button';
      shareButton.setAttribute('data-gtender-share', '');
      shareButton.setAttribute('data-gtender-share-id', id);
      let sharePending = false;

      async function handleTenderShare(event) {
        if (sharePending) return;

        const options =
          event.type === 'gtender:share-request'
            ? event.detail || {}
            : {};

        const host =
          options.host && root.contains(options.host)
            ? options.host
            : shareButton.parentElement || actionRow;

        const message = shareMessage(title);
        const fallback = shareClipboardText(title, shareUrl);

        function announce(text) {
          let status = host.querySelector('[data-gtender-share-status]');

          if (!status) {
            status = document.createElement('p');
            status.className = 'gtender-share-status';
            status.setAttribute('data-gtender-share-status', '');
            status.setAttribute('role', 'status');
            status.setAttribute('aria-live', 'polite');
            status.setAttribute('aria-atomic', 'true');
            host.appendChild(status);
          }

          status.textContent = text;
        }

        function showCopyText() {
          let input = host.querySelector('[data-gtender-share-link]');

          if (!input) {
            input = element('textarea', 'gtender-share-link');
            input.readOnly = true;
            input.setAttribute('data-gtender-share-link', '');
            host.appendChild(input);
          }

          input.setAttribute('aria-label', copy('copyLink'));
          input.value = fallback;
          announce(copy('copyLink'));
          input.focus();
          input.select();
        }

        sharePending = true;
        announce('');

        try {
          if (typeof navigator.share === 'function') {
            await navigator.share({
              title: 'GTender · ' + title,
              text: message,
              url: shareUrl
            });
          } else if (
            navigator.clipboard &&
            navigator.clipboard.writeText
          ) {
            await navigator.clipboard.writeText(fallback);
            announce(copy('copied'));
          } else {
            showCopyText();
          }
        } catch (error) {
          if (!error || error.name !== 'AbortError') {
            showCopyText();
          }
        } finally {
          sharePending = false;
        }
      }

      shareButton.addEventListener('click', handleTenderShare);
      shareButton.addEventListener(
        'gtender:share-request',
        handleTenderShare
      );

      actionRow.appendChild(shareButton);
    }
    card.appendChild(actionRow);
    var sameInstitution = /^(hkmu|hkust)$/.test(sourceKey(item));
    if (!sameInstitution) card.appendChild(element('p', 'gtender-public-record-meta', provenanceText(item)));
    return card;
  }

  function bindDetail(root) {
    var dialog = root.querySelector('[data-gtender-public-detail]');
    if (!dialog || dialog.getAttribute('data-detail-bound') === 'true') return;
    dialog.setAttribute('data-detail-bound', 'true');

    var boundState = stateByRoot.get(root);
    syncMemberDetailAccess(root, dialog);

    if (
      boundState &&
      !boundState.detailPresentationMedia &&
      window.matchMedia
    ) {
      const media = window.matchMedia('(min-width: 1024px)');

      const listener = () => {
        if (
          !boundState.active ||
          !root.isConnected ||
          dialog.hidden ||
          dialog.getAttribute('data-gtender-detail-visible') !== 'true'
        ) return;

        resetDetailDrag(dialog);
        syncDetailPresentation(root, dialog);
      };

      boundState.detailPresentationMedia = media;
      boundState.detailPresentationListener = listener;

      if (media.addEventListener) {
        media.addEventListener('change', listener);
      } else if (media.addListener) {
        media.addListener(listener);
      }
    }

    if (boundState && !boundState.memberSessionListener) {
      boundState.memberSessionListener = function () {
        if (!boundState.active || !root.isConnected) return;
        syncMemberDetailAccess(root, dialog);
      };
      document.addEventListener('littleg:web-session-change', boundState.memberSessionListener);
    }

    root.addEventListener('click', function (event) {
      const trigger = event.target && event.target.closest
        ? event.target.closest('[data-gtender-detail-open]')
        : null;

      if (!trigger || !root.contains(trigger)) return;

      const state = stateByRoot.get(root);
      const id = clean(trigger.getAttribute('data-gtender-detail-open'));
      if (!state || !state.active || !id) return;

      const items = Array.isArray(state.items) ? state.items : [];
      const item = items.find((entry) => {
        return clean(entry && (entry.id || entry.tender_id)) === id;
      });

      event.preventDefault();

      root.querySelectorAll(
        '.gtender-partner-entry__card'
      ).forEach((card) => {
        const detailTrigger = card.querySelector(
          '[data-gtender-detail-open]'
        );

        const selected = Boolean(
          detailTrigger &&
          clean(detailTrigger.getAttribute(
            'data-gtender-detail-open'
          )) === id
        );

        card.classList.toggle('is-selected', selected);

        const titleButton = card.querySelector(
          'button.gtender-card__title'
        );

        if (titleButton) {
          if (selected) {
            titleButton.setAttribute('aria-current', 'true');
          } else {
            titleButton.removeAttribute('aria-current');
          }
        }
      });

      void openDetail(
        root,
        item || { id: id, tender_id: id },
        trigger
      );
    });

    Array.prototype.forEach.call(dialog.querySelectorAll('[data-gtender-detail-close]'), function (button) {
      if (button.hasAttribute('data-gtender-detail-handle')) return;
      button.addEventListener('click', function () { closeDialog(root); });
    });
    dialog.addEventListener('click', function (event) {
      if (
        event.target === dialog &&
        dialog.getAttribute('data-gtender-detail-presentation') !== 'inline'
      ) {
        closeDialog(root);
      }
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog(root);
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog(root);
        return;
      }

      if (
        event.key !== 'Tab' ||
        dialog.getAttribute('data-gtender-detail-presentation') === 'inline'
      ) {
        return;
      }

      const nodes = detailFocusableNodes(dialog).filter((node) => {
        return node.getClientRects().length > 0;
      });

      if (!nodes.length) return;

      const first = nodes[0];
      const last = nodes[nodes.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    dialog.addEventListener('close', function () {
      const state = stateByRoot.get(root);

      if (state && state.detailPresentationCloses > 0) {
        state.detailPresentationCloses -= 1;
        return;
      }

      finalizeDetailClose(root, dialog);
    });

    var handle = dialog.querySelector('[data-gtender-detail-handle]');
    if (handle) {
      var startY = null;
      var dragY = 0;
      function resetGesture() {
        startY = null;
        dragY = 0;
        resetDetailDrag(dialog);
      }
      handle.addEventListener('pointerdown', function (event) {
        if (!event.isPrimary) return;
        startY = event.clientY;
        dragY = 0;
        dialog.setAttribute('data-gtender-dragging', 'true');
        try { handle.setPointerCapture(event.pointerId); } catch (_error) {}
      });
      handle.addEventListener('pointermove', function (event) {
        if (startY === null || !event.isPrimary) return;
        dragY = Math.max(0, event.clientY - startY);
        dialog.style.transform = 'translate3d(0,' + dragY + 'px,0)';
      });
      handle.addEventListener('pointerup', function (event) {
        if (startY === null) return;
        var shouldClose = dragY >= 64;
        try { handle.releasePointerCapture(event.pointerId); } catch (_error) {}
        if (shouldClose) closeDialog(root);
        else resetGesture();
        startY = null;
        dragY = 0;
      });
      handle.addEventListener('pointercancel', resetGesture);
      dialog.addEventListener('close', resetGesture);
    }
  }

  function openSharedTender(root) {
    var id = '';
    try { id = clean(new URL(window.location.href).searchParams.get('tender')); } catch (_error) {}
    if (!SHARED_TENDER_ID_RE.test(id)) return;
    root.setAttribute('data-gtender-active-detail-id', id);
    void openDetail(root, { id: id, tender_id: id, title: copy('publicTender') }, null);
  }

  function buildSearchUrl(root, state, projection) {
    var url = attachSourceClient(canonicalPublicEndpoint(root.getAttribute('data-tender-search-endpoint'), SEARCH_FALLBACK));
    var controls = {
      query: root.querySelector('[data-gtender-search-query]'),
      category: root.querySelector('[data-gtender-search-category]'),
      department: root.querySelector('[data-gtender-search-department]'),
      status: root.querySelector('[data-gtender-search-status]'),
      deadline: root.querySelector('[data-gtender-search-deadline]')
    };
    var query = clean(controls.query && controls.query.value);
    var category = clean(controls.category && controls.category.value);
    var department = clean(controls.department && controls.department.value);
    var status = clean(controls.status && controls.status.value);
    var deadline = clean(controls.deadline && controls.deadline.value);
    var institution = institutionMatch(query);
    if (query) url.searchParams.set('q', institution ? institution[2].replace(/^The /, '') : query);
    if (category) url.searchParams.set('category', category);
    if (department) url.searchParams.set('department', department);
    if (status) url.searchParams.set('status', status);
    if (deadline) url.searchParams.set('deadline', deadline);
    // Server ordering precedes cursor pagination; do not reverse just one visible page.
    url.searchParams.set('sort', state.sortOrder === 'deadline_desc' ? 'deadline_desc' : 'deadline_asc');
    url.searchParams.set('lang', localeFamily());

    var requestedView = projection === 'map' || projection === 'list'
      ? projection
      : state.viewMode;

    if (requestedView === 'map') {
      url.searchParams.set('view', 'map');
      url.searchParams.set('aggregate', 'place');
      url.searchParams.delete('cursor');
    } else {
      url.searchParams.delete('view');
      url.searchParams.delete('aggregate');
      var cursor = state.cursors[state.page - 1];
      if (cursor) url.searchParams.set('cursor', cursor);
    }

    url.searchParams.set('limit', String(SEARCH_PAGE_SIZE));
    return url;
  }

  function renderResults(root, state, items) {
    const container = root.querySelector('[data-gtender-public-results]');
    if (!container) return;
    container.replaceChildren();

    if (!items.length) {
      const empty = element('div', 'gtender-public-empty');
      empty.setAttribute('data-gtender-empty-state', 'results');
      const isChinese = localeFamily() === 'zh';
      const isZhHans = /^zh-CN$/i.test(clean(root.getAttribute('data-locale')));

      const visual = root.querySelector('[data-gtender-empty-visual-template]');
      if (visual && visual.content) {
        empty.appendChild(visual.content.cloneNode(true));
      }

      empty.appendChild(element(
        'h3',
        '',
        state.hasSearched
          ? isChinese
            ? '沒有符合條件的招標'
            : 'No tenders returned for these filters'
          : isChinese
            ? (isZhHans ? '本次搜索没有找到招标' : '本次搜尋沒有找到招標')
            : 'No tenders returned by this request'
      ));

      empty.appendChild(element(
        'p',
        '',
        state.hasSearched
          ? isChinese
            ? (isZhHans ? '试试其他关键词，或清除发布机构及截止日期筛选。' : '試試其他關鍵字，或清除發佈機構及截止日期篩選。')
            : 'No tenders match these filters. Try other keywords or clear the issuing organisation and closing date filters.'
          : isChinese
            ? (isZhHans ? '这次搜索没有找到招标。请重试；这不代表所有官方来源都没有招标。' : '這次搜尋沒有找到招標。請重試；這不代表所有官方來源都沒有招標。')
            : 'This request returned no tenders. Try again; this does not mean every official source has no tenders.'
      ));

      const action = element(
        'button',
        'gtender-public-empty__clear',
        state.hasSearched
          ? copy('clearFilters')
          : isChinese ? (isZhHans ? '重新搜索' : '重新搜尋') : 'Search again'
      );
      action.type = 'button';
      action.addEventListener('click', function () {
        if (!state.active) return;
        action.disabled = true;
        if (state.hasSearched) {
          clearSearch(root, state);
        } else {
          search(root, state);
        }
      });

      empty.appendChild(action);
      container.appendChild(empty);
      return;
    }

    items.forEach(function (item) {
      container.appendChild(renderTender(root, item));
    });
  }

  function setSelectOptions(select, values, labeler, allLabel) {
    if (!select) return;
    var selected = select.value;
    if (selected && values.indexOf(selected) === -1) values = values.concat(selected);
    select.replaceChildren();
    var all = document.createElement('option');
    all.value = '';
    const fieldLabel = select
      .closest('.gtender-public-search__field')
      ?.querySelector('span');
    all.textContent =
      clean(select.getAttribute('data-placeholder-text')) ||
      clean(fieldLabel?.textContent) ||
      allLabel;
    select.appendChild(all);
    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = labeler ? labeler(value) : value;
      select.appendChild(option);
    });
    select.value = selected;
  }

  function setFilterOptions(root, state, facets) {
    var categories = Array.isArray(facets.categories) ? facets.categories.map(clean).filter(Boolean) : [];
    var departments = Array.isArray(facets.departments) ? facets.departments.map(clean).filter(Boolean) : [];
    if (!categories.length && !departments.length) return;
    categories.sort(); departments.sort();
    setSelectOptions(root.querySelector('[data-gtender-search-category]'), categories, categoryLabel, copy('allCategories'));
    setSelectOptions(root.querySelector('[data-gtender-search-department]'), departments, null, /^zh-CN$/i.test(clean(root.getAttribute('data-locale'))) ? '全部机构' : copy('allDepartments'));
  }

  async function readPublicJson(url, controller) {
    const requestController = controller || new AbortController();
    let timeoutId;

    const timeout = new Promise(function (_resolve, reject) {
      timeoutId = window.setTimeout(function () {
        const error = new Error('public_request_timeout');
        error.code = 'gtender_public_timeout';
        reject(error);
        requestController.abort();
      }, 10000);
    });

    const request = (async function () {
      const response = await fetch(url.toString(), {
        method: 'GET',
        credentials: 'omit',
        signal: requestController.signal,
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('public_request_unavailable');

      const payload = await response.json();
      if (
        !payload ||
        typeof payload !== 'object' ||
        Array.isArray(payload) ||
        payload.ok === false ||
        payload.success === false
      ) {
        throw new Error('public_payload_unavailable');
      }

      return payload;
    })();

    try {
      return await Promise.race([request, timeout]);
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  function applyListProjection(root, state, payload) {
    var normalizedPayload = normalizeSearchPayload(payload);
    state.items = normalizedPayload.items;
    state.totalPages = normalizedPayload.totalPages;
    state.nextCursor = normalizedPayload.nextCursor;
    state.hasMore = normalizedPayload.hasMore && Boolean(state.nextCursor);
    state.total = normalizedPayload.total;
    state.verifiedAt = normalizedPayload.verifiedAt || state.verifiedAt;
    updateSyncTime(root, state, state.items.map(function (item) { return recordVerifiedAt(item, ''); }));
    renderResults(root, state, state.items);
    setFilterOptions(root, state, normalizedPayload.facets);
  }

  async function search(root, state) {
    if (!root || !state.active) return;
    state.requestSequence += 1;
    var sequence = state.requestSequence;
    var isMap = state.viewMode === 'map';
    if (state.controller) state.controller.abort();
    state.controller = new AbortController();
    setStatus(root, isMap
      ? copy('mapLoading')
      : copy('searching'));
    root.setAttribute('data-source-health-state', state.sourceHealth || 'checking');
    var container = root.querySelector('[data-gtender-public-results]');
    if (container) {
      container.setAttribute('aria-busy', 'true');
    }
    if (container && !isMap) {
      container.replaceChildren();

      for (let index = 0; index < 3; index += 1) {
        const skeleton = document.createElement('div');
        skeleton.className = 'gtender-public-skeleton';
        skeleton.setAttribute('aria-hidden', 'true');

        for (let line = 0; line < 4; line += 1) {
          skeleton.appendChild(document.createElement('span'));
        }

        container.appendChild(skeleton);
      }
    }
    setPagination(root, state, true);
    try {
      if (isMap) {
        const [mapPayload, listPayload] = await Promise.all([
          readPublicJson(
            buildSearchUrl(root, state, 'map'),
            state.controller
          ),
          readPublicJson(
            buildSearchUrl(root, state, 'list'),
            state.controller
          )
        ]);
        if (!state.active || sequence !== state.requestSequence) return;

        applyListProjection(root, state, listPayload);
        state.mapResult = normalizeOpportunityMapPayload(mapPayload);
        renderOpportunityMap(root, state.mapResult);

        root.dispatchEvent(new CustomEvent('gtender:c21-map-response', {
          bubbles: true,
          detail: {
            payload: mapPayload,
            requestSequence: sequence
          }
        }));

        setPagination(root, state);
        setStatus(root, '');
        return;
      }

      const payload = await readPublicJson(
        buildSearchUrl(root, state, 'list'),
        state.controller
      );
      if (!state.active || sequence !== state.requestSequence) return;

      applyListProjection(root, state, payload);
      setPagination(root, state);
      setStatus(root, '');
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      if (!state.active || sequence !== state.requestSequence) return;

      if (isMap) {
        state.mapResult = null;
        renderOpportunityMapError(root);
        setStatus(root, '');
        return;
      }

      state.items = [];
      state.hasMore = false;
      state.nextCursor = '';
      state.total = 0;
      state.totalPages = 1;

      // Request failure is not a successful search with zero results.
      if (container) {
        const failure = element('div', 'gtender-public-empty gtender-public-error');
        failure.setAttribute('role', 'status');

        const iconNamespace = 'http://www.w3.org/2000/svg';
        const failureIcon = document.createElementNS(iconNamespace, 'svg');
        failureIcon.setAttribute('class', 'gtender-public-error__icon');
        failureIcon.setAttribute('viewBox', '0 0 24 24');
        failureIcon.setAttribute('width', '28');
        failureIcon.setAttribute('height', '28');
        failureIcon.setAttribute('fill', 'none');
        failureIcon.setAttribute('stroke', 'currentColor');
        failureIcon.setAttribute('stroke-width', '1.5');
        failureIcon.setAttribute('stroke-linecap', 'round');
        failureIcon.setAttribute('stroke-linejoin', 'round');
        failureIcon.setAttribute('aria-hidden', 'true');
        failureIcon.setAttribute('focusable', 'false');

        const failurePath = document.createElementNS(iconNamespace, 'path');
        failurePath.setAttribute(
          'd',
          'M10.3 3.9 2.2 18a2 2 0 0 0 1.7 3h16.2a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0ZM12 9v4m0 4h.01'
        );
        failureIcon.appendChild(failurePath);
        failure.appendChild(failureIcon);

        failure.appendChild(element(
          'h3',
          '',
          copy('loadFailed')
        ));

        failure.appendChild(element(
          'p',
          '',
          copy('retryHint')
        ));

        const retry = element(
          'button',
          'gtender-public-empty__clear',
          copy('retryAction')
        );
        retry.type = 'button';
        retry.addEventListener('click', function () {
          if (!state.active) return;
          retry.disabled = true;
          loadSourceHealth(root, state);
          search(root, state);
        });

        const sourceNote = element(
          'p',
          'gtender-public-error__source',
          copy('sourceStatusUnavailable')
        );

        failure.appendChild(sourceNote);
        failure.appendChild(retry);
        container.replaceChildren(failure);
      }

      setStatus(root, '');
    } finally {
      if (state.active && sequence === state.requestSequence) {
        if (container) container.setAttribute('aria-busy', 'false');
        setPagination(root, state);
      }
    }
  }

  function setPagination(root, state, busy) {
    var previous = root.querySelector('[data-gtender-page-previous]');
    var next = root.querySelector('[data-gtender-page-next]');
    var info = root.querySelector('[data-gtender-page-info]');
    const navigation = root.querySelector('.gtender-public-pagination');
    const hasResults = Array.isArray(state.items) && state.items.length > 0;
    const exportButton = root.querySelector('[data-gtender-export-csv]');

    if (exportButton) {
      const exportUnavailable =
        !state.active ||
        Boolean(busy) ||
        state.viewMode === 'map' ||
        !hasResults;

      exportButton.disabled = exportUnavailable;
      exportButton.hidden = exportUnavailable;

      if (exportUnavailable) {
        exportButton.style.display = 'none';
      } else {
        exportButton.style.removeProperty('display');
      }
    }

    if (navigation) {
      navigation.hidden =
        Boolean(busy) ||
        !hasResults ||
        (!state.hasMore && state.page <= 1);
    }

    if (previous) previous.disabled = Boolean(busy) || state.page <= 1;
    if (next) next.disabled = Boolean(busy) || !state.hasMore;
    if (info) info.textContent = state.totalPages > 1 ? state.page + ' / ' + state.totalPages : '';
  }

  function resetPagination(state) {
    state.page = 1; state.cursors = ['']; state.nextCursor = ''; state.hasMore = false;
  }

  function clearSearch(root, state) {
    ['[data-gtender-search-query]', '[data-gtender-search-category]', '[data-gtender-search-department]', '[data-gtender-search-status]', '[data-gtender-search-deadline]'].forEach(function (selector) {
      var input = root.querySelector(selector); if (input) input.value = '';
    });
    syncSearchQuery(root);
    resetPagination(state); state.hasSearched = false; search(root, state);
  }

  function syncSearchQuery(root) {
    try {
      var input = root.querySelector('[data-gtender-search-query]');
      var query = clean(input && input.value).slice(0, 200);
      var url = new URL(window.location.href);
      if (query) url.searchParams.set('q', query);
      else url.searchParams.delete('q');
      if (url.toString() !== window.location.href) {
        window.history.pushState({}, '', url.toString());
      }
    } catch (_error) {}
  }

  function deadlineSortFromLocation() {
    try {
      return new URL(window.location.href).searchParams.get('sort') === 'deadline_desc'
        ? 'deadline_desc' : 'deadline_asc';
    } catch (_error) { return 'deadline_asc'; }
  }

  function renderDeadlineSort(root, state) {
    var button = root.querySelector('[data-gtender-sort-deadline]');
    if (!button) return;
    var nearest = state.sortOrder !== 'deadline_desc';
    var zh = localeFamily() === 'zh';
    button.setAttribute('data-sort-direction', nearest ? 'asc' : 'desc');
    button.setAttribute('aria-pressed', String(!nearest));
    button.setAttribute('aria-label', nearest
      ? (zh ? '截止日期：最近優先。切換為最遠優先' : 'Deadline: nearest first. Switch to furthest first')
      : (zh ? '截止日期：最遠優先。切換為最近優先' : 'Deadline: furthest first. Switch to nearest first'));
    button.setAttribute('title', button.getAttribute('aria-label'));
    var label = button.querySelector('[data-gtender-sort-label]');
    if (label) label.textContent = nearest ? (zh ? '最近截止' : 'Soonest') : (zh ? '最遠截止' : 'Latest');
  }

  function bindDeadlineSort(root, state) {
    var button = root.querySelector('[data-gtender-sort-deadline]');
    state.sortOrder = deadlineSortFromLocation();
    renderDeadlineSort(root, state);
    if (!button) return;
    state.deadlineSortListener = function () {
      if (!state.active) return;
      state.sortOrder = state.sortOrder === 'deadline_asc' ? 'deadline_desc' : 'deadline_asc';
      renderDeadlineSort(root, state);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('sort', state.sortOrder);
        window.history.pushState({}, '', url.toString());
      } catch (_error) {}
      resetPagination(state);
      state.hasSearched = true;
      search(root, state);
    };
    button.addEventListener('click', state.deadlineSortListener);
  }

  function bindView(root, state) {
    var controls = root.querySelector('[data-gtender-view-controls]');
    var workspace = root.querySelector('[data-gtender-map-workspace]');
    var listToggle = root.querySelector('[data-gtender-view-toggle="list"]');
    var mapToggle = root.querySelector('[data-gtender-view-toggle="map"]');
    if (!controls || !workspace || !listToggle || !mapToggle) {
      state.viewMode = 'list';
      state.view = 'list';
      root.setAttribute('data-gtender-view-mode', 'list');
      return;
    }

    controls.hidden = false;
    controls.removeAttribute('aria-hidden');

    function locationMode() {
      try { return new URL(window.location.href).searchParams.get('view') === 'map' ? 'map' : 'list'; }
      catch (_error) { return 'list'; }
    }

    function writeLocation(mode, method) {
      try {
        var url = new URL(window.location.href);
        if (mode === 'map') url.searchParams.set('view', 'map');
        else url.searchParams.delete('view');
        window.history[method || 'replaceState']({}, '', url.toString());
      } catch (_error) {}
    }

    function apply(mode, options) {
      if (!state.active) return;

      const next = mode === 'map' ? 'map' : 'list';
      const config = options || {};
      const currentWorkspace = root.querySelector(
        '[data-gtender-map-workspace]'
      );

      if (!currentWorkspace) return;

      state.viewMode = next;
      state.view = next;

      currentWorkspace.hidden = next !== 'map';
      root.setAttribute('data-gtender-view-mode', next);

      root.querySelectorAll(
        '[data-gtender-view-toggle]'
      ).forEach((button) => {
        const selected =
          button.getAttribute('data-gtender-view-toggle') === next;

        button.setAttribute('aria-pressed', String(selected));
      });

      if (config.writeUrl) {
        writeLocation(
          next,
          config.historyMethod || 'replaceState'
        );
      }

      setPagination(root, state);

      if (config.search) {
        resetPagination(state);
        search(root, state);
      }
    }

    state.viewClickListener = function (event) {
      if (!state.active) return;

      const target = event.target;
      const button = target && target.closest
        ? target.closest('[data-gtender-view-toggle]')
        : null;

      if (
        !button ||
        !root.contains(button) ||
        button.disabled
      ) return;

      const next = button.getAttribute(
        'data-gtender-view-toggle'
      );

      if (next !== 'list' && next !== 'map') return;

      event.preventDefault();

      const changed = next !== state.viewMode;

      apply(next, {
        writeUrl: changed,
        historyMethod: 'pushState',
        search: changed
      });
    };

    root.addEventListener('click', state.viewClickListener);

    state.viewPopstateListener = function () {
      if (!state.active) return;
      var next = locationMode();
      var input = root.querySelector('[data-gtender-search-query]');
      var query = '';
      try { query = clean(new URL(window.location.href).searchParams.get('q')).slice(0, 200); } catch (_error) {}
      var queryChanged = Boolean(input) && clean(input.value) !== query;
      var nextSort = deadlineSortFromLocation();
      var sortChanged = nextSort !== state.sortOrder;
      if (queryChanged) input.value = query;
      if (sortChanged) {
        state.sortOrder = nextSort;
        renderDeadlineSort(root, state);
        resetPagination(state);
      }
      if (next !== state.viewMode) {
        apply(next, { writeUrl: false, search: true });
      } else if (queryChanged || sortChanged) {
        if (!sortChanged) resetPagination(state);
        state.hasSearched = Boolean(query) || sortChanged;
        search(root, state);
      }
    };
    window.addEventListener('popstate', state.viewPopstateListener);
    apply(locationMode(), { writeUrl: false, search: false });
  }

  function bindSearchHistory(root, state, form) {
    var input = root.querySelector('[data-gtender-search-query]');
    var panel = root.querySelector('[data-gtender-search-history]');
    if (!input || !panel) return function () {};
    var key = 'littleg:gtender-search-history:v1';
    var history = [];
    function normalize(values) {
      var seen = Object.create(null);
      return (Array.isArray(values) ? values : []).filter(function (value) {
        if (typeof value !== 'string') return false;
        var text = clean(value).slice(0, 200);
        if (!text || seen[text.toLowerCase()]) return false;
        seen[text.toLowerCase()] = true; return true;
      }).map(function (value) { return clean(value).slice(0, 200); }).slice(0, 8);
    }
    try { history = normalize(JSON.parse(window.localStorage.getItem(key) || '[]')); } catch (_error) {}
    function persist() {
      try {
        if (history.length) window.localStorage.setItem(key, JSON.stringify(history));
        else window.localStorage.removeItem(key);
      } catch (_error) {}
    }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function render(open) {
      panel.replaceChildren();
      panel.appendChild(element('p', 'gtender-search-history__heading', copy('recentSearches')));
      history.forEach(function (value, index) {
        var row = element('div', 'gtender-search-history__row');
        var use = element('button', 'gtender-search-history__use', value); use.type = 'button';
        use.addEventListener('click', function () {
          input.value = value; close(); input.focus(); close();
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
        var remove = element('button', 'gtender-search-history__remove', '×'); remove.type = 'button';
        remove.setAttribute('aria-label', (copy('deleteSearch')) + value);
        remove.addEventListener('click', function () {
          history.splice(index, 1); persist(); render(true);
          var target = panel.querySelector('button'); if (target) target.focus(); else input.focus();
        });
        row.appendChild(use); row.appendChild(remove); panel.appendChild(row);
      });
      var clear = element('button', 'gtender-search-history__clear', copy('clearSearchHistory')); clear.type = 'button';
      clear.addEventListener('click', function () { history = []; persist(); close(); input.focus(); });
      panel.appendChild(clear);
      panel.hidden = !open || !history.length;
      input.setAttribute('aria-expanded', String(!panel.hidden));
    }
    input.setAttribute('aria-controls', panel.id); input.setAttribute('aria-expanded', 'false');
    input.addEventListener('focus', function () { render(true); });
    input.addEventListener('click', function () { render(true); });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' && history.length) { event.preventDefault(); render(true); panel.querySelector('button').focus(); }
      if (event.key === 'Escape') close();
    });
    panel.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); input.focus(); close(); } });
    form.addEventListener('focusout', function (event) { if (event.relatedTarget !== input && !panel.contains(event.relatedTarget)) close(); });
    root.addEventListener('click', function (event) { if (!panel.contains(event.target) && event.target !== input) close(); });
    return function () {
      var value = clean(input.value).slice(0, 200);
      if (value) { history = normalize([value].concat(history)); persist(); }
      close();
    };
  }

  function bindSearch(root, state) {
    var form = root.querySelector('[data-gtender-public-search]');
    if (!form) return;

    const exportButton = root.querySelector('[data-gtender-export-csv]');

    if (exportButton) {
      exportButton.addEventListener('click', function () {
        const results = root.querySelector('[data-gtender-public-results]');

        if (
          !state.active ||
          exportButton.disabled ||
          state.viewMode === 'map' ||
          results?.getAttribute('aria-busy') === 'true' ||
          !Array.isArray(state.items) ||
          !state.items.length
        ) {
          return;
        }

        const zh = localeFamily() === 'zh';

        const csvCell = function (value) {
          const raw = String(value == null ? '' : value);
          const safe = /^[\s\u0000-\u001f]*[=+\-@]/.test(raw) ||
            /^[\t\r\n]/.test(raw)
            ? "'" + raw
            : raw;

          return '"' + safe.replace(/"/g, '""') + '"';
        };

        const headers = zh
          ? [
              '招標編號',
              '招標名稱',
              '發布機構',
              '發布日期（來源原文）',
              '截止日期（來源原文）',
              '狀態',
              '官方來源'
            ]
          : [
              'Tender reference',
              'Title',
              'Issuing department',
              'Published date (source value)',
              'Deadline (source value)',
              'Status',
              'Official source'
            ];

        const rows = state.items.map(function (item) {
          return [
            detailReference(item),
            detailSubject(item),
            detailDepartment(item),
            clean(item && (item.issue_datetime_raw || item.published_at)),
            clean(item && (item.closing_datetime_raw || item.deadline)),
            lifecycleInfo(item).label,
            safeOfficialUrl(
              item && (item.official_url || item.source_url || item.url)
            ) || ''
          ];
        });

        const csv = [headers].concat(rows).map(function (row) {
          return row.map(csvCell).join(',');
        }).join('\r\n');

        const blob = new Blob(
          ['\uFEFF', csv],
          { type: 'text/csv;charset=utf-8;' }
        );

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = downloadUrl;
        link.download = 'gtender-current-page.csv';
        link.hidden = true;
        document.body.appendChild(link);

        try {
          link.click();
        } finally {
          link.remove();
          window.setTimeout(function () {
            window.URL.revokeObjectURL(downloadUrl);
          }, 1000);
        }
      });
    }

    var rememberSearch = bindSearchHistory(root, state, form);
    form.addEventListener('submit', function (event) { event.preventDefault(); rememberSearch(); syncSearchQuery(root); resetPagination(state); state.hasSearched = true; search(root, state); });
    var clear = root.querySelector('[data-gtender-search-clear]');
    if (clear) clear.addEventListener('click', function () { clearSearch(root, state); });
    ['[data-gtender-search-category]', '[data-gtender-search-department]', '[data-gtender-search-status]', '[data-gtender-search-deadline]'].forEach(function (selector) {
      var input = root.querySelector(selector); if (input) input.addEventListener('change', function () { resetPagination(state); state.hasSearched = true; search(root, state); });
    });
    var previous = root.querySelector('[data-gtender-page-previous]');
    var next = root.querySelector('[data-gtender-page-next]');
    if (previous) previous.addEventListener('click', function () { if (state.page > 1) { state.page -= 1; search(root, state); } });
    if (next) next.addEventListener('click', function () { if (state.hasMore && state.nextCursor) { state.cursors[state.page] = state.nextCursor; state.page += 1; search(root, state); } });
  }

  async function loadSourceHealth(root, state) {
    if (!root || !state.active) return;

    state.sourceRequestSequence = (state.sourceRequestSequence || 0) + 1;
    const sequence = state.sourceRequestSequence;
    const isCurrent = function () {
      return state.active &&
        root.isConnected &&
        sequence === state.sourceRequestSequence;
    };

    root.setAttribute('data-source-health-state', 'checking');

    try {
      const endpoint = attachSourceClient(canonicalPublicEndpoint(
        root.getAttribute('data-source-status-endpoint'),
        SOURCE_STATUS_FALLBACK
      ));
      const payload = await readPublicJson(endpoint);
      if (!isCurrent()) return;

      const data = responseData(payload);
      if (!data || typeof data !== 'object' || Array.isArray(data)) {
        throw new Error('source_status_unavailable');
      }

      const health = clean(data.state || data.status || data.health).toLowerCase();
      const mapped = ['normal', 'current', 'ok', 'healthy'].includes(health)
        ? 'current'
        : ['stale', 'delayed'].includes(health) ? 'stale' : 'error';

      const sources = data.sources &&
        typeof data.sources === 'object' &&
        !Array.isArray(data.sources) ? data.sources : {};

      state.sourceHealth = mapped;
      state.sources = sources;
      state.verifiedAt = clean(
        data.updated_at ||
        data.last_verified_at ||
        data.last_seen_at ||
        data.generated_at ||
        state.verifiedAt
      );

      root.setAttribute('data-source-health-state', mapped);
      root.setAttribute(
        'data-source-freshness',
        mapped === 'current' ? 'normal' : mapped === 'error' ? 'source-error' : 'stale'
      );

      updateSyncTime(root, state, [
        data.last_verified_at,
        data.last_seen_at
      ].concat(Object.keys(sources).map(function (key) {
        const source = sources[key];
        return source && source.ok ? source.fetched_at : '';
      })));
      renderSourceSummary(root, state);
    } catch (_error) {
      if (!isCurrent()) return;

      state.sources = {};
      state.sourceHealth = 'error';
      root.setAttribute('data-source-health-state', 'error');
      root.setAttribute('data-source-freshness', 'source-error');
      renderSourceSummary(root, state);
    }
  }

  function mount(root) {
    if (!root || stateByRoot.has(root)) return;
    var state = { active: true, controller: null, detailController: null, requestSequence: 0, items: [], page: 1, cursors: [''], nextCursor: '', hasMore: false, totalPages: 1, total: 0, hasSearched: false, verifiedAt: '', syncAt: '', sources: {}, healthDismissed: false, sourceHealth: 'checking', detailTrigger: null, memberSessionListener: null, viewMode: 'list', view: 'list', mapResult: null, viewPopstateListener: null };
    stateByRoot.set(root, state);
    var dismiss = root.querySelector('[data-gtender-source-health-dismiss]');
    if (dismiss) dismiss.addEventListener('click', function () { state.healthDismissed = true; renderSourceSummary(root, state); });
    var initialInput = root.querySelector('[data-gtender-search-query]');
    if (initialInput) {
      try {
        var initialQuery = clean(new URL(window.location.href).searchParams.get('q')).slice(0, 200);
        if (initialQuery) {
          initialInput.value = initialQuery;
          state.hasSearched = true;
        }
      } catch (_error) {}
    }
    bindDeadlineSort(root, state);
    bindView(root, state);
    bindSearch(root, state);
    bindDetail(root);
    loadSourceHealth(root, state);
    search(root, state);
    openSharedTender(root);
  }

  function destroy(root) {
    var state = root ? stateByRoot.get(root) : null;
    if (!state) return;
    state.active = false;
    state.requestSequence += 1;
    if (state.controller) state.controller.abort();
    if (state.detailController) state.detailController.abort();
    if (state.memberSessionListener) {
      document.removeEventListener('littleg:web-session-change', state.memberSessionListener);
      state.memberSessionListener = null;
    }
    if (state.deadlineSortListener) {
      var sortButton = root.querySelector('[data-gtender-sort-deadline]');
      if (sortButton) sortButton.removeEventListener('click', state.deadlineSortListener);
      state.deadlineSortListener = null;
    }
    if (state.viewClickListener) {
      root.removeEventListener(
        'click',
        state.viewClickListener
      );
      state.viewClickListener = null;
    }

    if (state.viewPopstateListener) {
      window.removeEventListener(
        'popstate',
        state.viewPopstateListener
      );
      state.viewPopstateListener = null;
    }
    if (
      state.detailPresentationMedia &&
      state.detailPresentationListener
    ) {
      const media = state.detailPresentationMedia;
      const listener = state.detailPresentationListener;

      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else if (media.removeListener) {
        media.removeListener(listener);
      }

      state.detailPresentationMedia = null;
      state.detailPresentationListener = null;
    }

    if (root.hasAttribute('data-gtender-detail-visible')) {
      document.documentElement.classList.remove('gtender-detail-open');
    }

    if (
      state.detailPresentationMedia &&
      state.detailPresentationListener
    ) {
      const media = state.detailPresentationMedia;
      const listener = state.detailPresentationListener;

      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else if (media.removeListener) {
        media.removeListener(listener);
      }

      state.detailPresentationMedia = null;
      state.detailPresentationListener = null;
    }

    if (root.hasAttribute('data-gtender-detail-visible')) {
      document.documentElement.classList.remove('gtender-detail-open');
    }

    stateByRoot.delete(root);
  }

  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) mount(target);
    Array.prototype.forEach.call(target.querySelectorAll ? target.querySelectorAll(ROOT_SELECTOR) : [], mount);
  }

  function destroyAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) destroy(target);
    Array.prototype.forEach.call(target.querySelectorAll ? target.querySelectorAll(ROOT_SELECTOR) : [], destroy);
  }

  function clearCachedGreeting() {
    var heading = document.querySelector('[data-gtender-greeting-fallback]');
    if (!heading) return;
    heading.textContent = heading.getAttribute('data-gtender-greeting-fallback');
  }

  window.addEventListener('pagehide', clearCachedGreeting);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) clearCachedGreeting();
  });

  document.addEventListener('shopify:section:load', function (event) { boot(event.target || document); });
  document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target || document); });
  window.__GTENDER_PUBLIC_ENTRY_RUNTIME__ = Object.freeze({ version: VERSION, boot: boot, destroy: destroyAll });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
})();
